<template>
    <div v-wechat-title="title" class="schedule-surgery">
        <crud-facecade
            ref="surgery-list"
            :key="1"
            :tableStyle="tableStyle"
            :tableHeight="tableHeight"
            :url="url"
            v-if="this.active_room_id > 0"
            :columns="columnList3"
            :customFixedColumns="customScheduleFixedColumns"
            :buttons="buttons"
            dialogWidth="80%"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :sort="true"
            :defaultSort="{ prop: 'scheduled_sequence' }"
            @exchange-row="dragSort"
            :rowDropDisabled="false"
            :columnConfig="true"
            :showSequence="false"
            @cancelSchedule="cancelSchedule"
            :selection="true"
            @loadSurgeryEditView="loadSurgeryEditView"
            @selectionChange="checkedRow"
            @printOne="printOne"
            :filterSpan="[15, 5, 6]"
            :stripe="scheduleSurgeryRowStyleConfig==`0`"
        >
            <slot slot="filter">
                <el-col :md="5" :xl="4" class="align-left">
                    <item-input type="datearraw2" v-model="scheduling_date" style="width: 160px"></item-input>
                </el-col>
                <el-col :md="11" :xl="12" class="align-left">
                    <el-button :type="isLoadToSchedule ? 'primary' : 'plain'" size="mini" @click="LoadUnScheduled()" title="待排程">
                        <span style="float: right; padding-right: 1px">待排程({{ unScheduledLength }})</span></el-button
                    >
                    <el-button :type="isLoadScheduled ? 'primary' : 'plain'" size="mini" @click="LoadAllScheduled()" title="已排程">
                        <span style="float: right; padding-right: 1px">已排程({{ ScheduledLength }})</span>
                    </el-button>
                    <el-button v-show="showCancelScheduledList" :type="isLoadCancelScheduled ? 'primary' : 'plain'" size="mini" @click="LoadCancelScheduled()" title="取消排程">
                        <span style="float: right; padding-right: 1px">取消排程({{ cancelScheduledLength }})</span>
                    </el-button>
                    <span title="已完成/未开始" style="font-weight: 600;">{{ScheduledLength1}}/<span :style="{ color: (ScheduledLength0 > 0) ? 'red' : 'black' }">{{ScheduledLength0}}</span></span>
                    <el-checkbox v-model="dataArea">全部</el-checkbox>
                </el-col>
                <el-col :md="3" :xl="3">
                    <item-input type="select" v-if="!IsHavePermission(`scheduling:CrossRegionScheduling`)" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                    <item-input type="multiselect" v-else v-model="dic_operating_ward_id_arr" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :md="3" :xl="2">
                    <item-input type="select" v-model="dic_section_id" :options="getsectionauth" :clearable="true" placeholder="请选择科室"></item-input>
                </el-col>
                <el-col :md="3" :xl="2">
                    <item-input type="select" v-model="selectsurgeryType" :options="surgeryTypes" placeholder="类型" @input="changed"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <!-- v-has-permission="createapplyPermission" -->
                <el-button type="primary" size="mini"  @click="openaddfrom()">创建手术</el-button>
                <el-button type="primary" v-show="this.surgeryinfopush == `true`" size="mini" @click="pushSchedule()" title="手术排程回传">排程回传<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="refreshList()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-dropdown @command="cancel">
                    <el-button type="primary" size="mini" v-show="isHaveCancelSchedule(`all`)">取消驳回<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cancelSchedule" v-show="isHaveCancelSchedule(`cancelSchedule`)">取消排程</el-dropdown-item>
                        <el-dropdown-item command="cancelSurgery" v-has-permission="cancelSurgeryPermission">取消手术</el-dropdown-item>
                        <el-dropdown-item command="rejectApprove" v-show="isHaveCancelSchedule(`rejectApprove`)">驳回审核</el-dropdown-item>
                        <el-dropdown-item command="rejectApply" v-show="isHaveCancelSchedule(`rejectApply`)">驳回申请</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="loadScheduleHelper">
                    <el-button type="primary" size="mini" v-show="ishavehelpSection(`all`)">排程助手<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="section" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpSection`)">按科室分配</el-dropdown-item>
                        <el-dropdown-item command="worker" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpWorker`)">按术者分配</el-dropdown-item>
                        <el-dropdown-item command="surgery" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpSurgery`)">按术式分配</el-dropdown-item>
                        <el-dropdown-item command="autoOneKeySchedule" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpOneKeySchedule`)">一键排程</el-dropdown-item>
                        <el-dropdown-item command="changeRoom" v-show="ishavehelpSection(`helpChangeRoom`)">更换手术间</el-dropdown-item>
                        <el-dropdown-item command="setAnesDoctor" v-show="ishavehelpSection(`helpSetAnesDoctor`)">设置麻醉医生</el-dropdown-item>
                        <el-dropdown-item command="clearWorkers">清除人员安排</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="printSurenry">
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in printSurgeryConfigs" :key="item.code" v-text="item.value" :command="item"></el-dropdown-item>
                        <!-- <el-dropdown-item command="PC008">打印手术信息</el-dropdown-item>
                        <el-dropdown-item command="PC009">打印首台通知</el-dropdown-item>
                         <el-dropdown-item command="PC007">打印排程列表</el-dropdown-item> -->
                        <el-dropdown-item command="ExportExcel">导出Excel</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <div ref="roomrow" slot="table-title">
                <el-row style="display: flex; align-items: center">
                    <el-col v-show="isShowScrollPane && isShowMoreRoom" :md="0.5" :xl="0.5" :class="{ height60: !roomCardShowWorkers, height70: roomCardShowWorkers, 'align-left': true}">
                        <i
                            style="line-height: 50px"
                            @mouseenter="startScroll($event, 'left')"
                            @mouseleave="endScroll"
                            @dragenter="startScroll($event, 'left')"
                            @dragover="dragover"
                            @dragleave="endScroll"
                            class="el-icon-caret-left more"
                        ></i>
                    </el-col>
                    <el-col :md="23" :xl="23" class="align-left" :class="{ height60: isShowScrollPane && !roomCardShowWorkers, height70: isShowScrollPane &&  roomCardShowWorkers}">
                        <ScrollPane v-if="isShowScrollPane" key="active_scrollPane" class="height-p100" ref="scrollpaneRef">
                            <draggable
                                class="height-p100 padding-right20"
                                ref="draggablePanel"
                                v-model="operationRoom"
                                v-bind="{ group: { name: 'card', pull: false, put: false }, animation: 150, handle: '.el-icon-sort' }"
                                @change="exchangeRoom"
                            >
                                <div
                                    class="inline-block margin2 margin-none-v cursor-pointer room"
                                    style="min-width: 80px; position: relative"
                                    :class="{'is-close': !room.is_open, 'is-operating': room.is_operating,height50: !roomCardShowWorkers, height70: roomCardShowWorkers}"
                                    v-for="room in operationRoom"
                                    :key="room.id"
                                >
                                    <span class="el-icon-sort" v-show="active_room_id == room.id" style="position: absolute; z-index: 1000; color: var(--primary-color, #009688)"></span>
                                    <draggable v-bind="roomDragOption(room.is_open)" @add="ScheduleSurgeries($event, room)">
                                        <div @click="LoadActiveRoomData($event, room)" :class="{height50: !roomCardShowWorkers, height70: roomCardShowWorkers}">
                                            <el-row class="height-p100">
                                                <el-col :span="2" class="height-p100 title"> &nbsp; </el-col>
                                                <el-col
                                                    :span="22"
                                                    class="content padding5 padding-none-v height-p100"
                                                    :class="{ active: active_room_id == room.id || scrolling_in_id == room.id }"
                                                    :style="styleObject(active_room_id == room.id || scrolling_in_id == room.id, room.room_setting)"
                                                    @dragenter.native="dragInRoom($event, room.id)"
                                                    @dragover.native="dragover"
                                                    @dragleave.native="dragOutRoom"
                                                    @dragend.native="dragOutRoom"
                                                >
                                                    <el-row class="font-size10" @click="active_room_id = room.id" style="height: 22px">
                                                        <el-col
                                                            :span="10"
                                                            class="line-height20"
                                                            v-if="isShowRejectCount == 0"
                                                            key="active_scroll_norejectCount"
                                                            :style="active_room_id == room.id ? 'padding-left:10px' : ''"
                                                        >
                                                            {{ room.done }}/{{ room.total }}
                                                        </el-col>
                                                        <el-col :span="10" class="line-height20" v-else key="active_scroll_rejectCount" :style="active_room_id == room.id ? 'padding-left:10px' : ''">
                                                            <span>{{ room.done }}/{{ room.total }}/</span><span style="color: red">{{ room.rejectCount }}</span>
                                                        </el-col>
                                                        <el-col :span="14" class="line-height20 align-right">
                                                            <span style="font-size: 11px; cursor: pointer">
                                                                <i
                                                                    class="el-icon-message-solid"
                                                                    title="当前手术间未具备手术资格"
                                                                    @click.stop="loadCheckList(room)"
                                                                    v-show="room.room_setting && room.room_setting.check_result == '不合格'"
                                                                ></i>
                                                            </span>
                                                            <span style="font-size: 11px" @click.stop="loadSettingForm(room)" :class="{ hasSetting: room.room_setting }">
                                                                <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                                            </span>
                                                        </el-col>
                                                    </el-row>
                                                    <span class="align-center" style="white-space: nowrap; line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex">{{
                                                        room.name
                                                    }}</span>
                                                    <el-row v-if="roomCardShowWorkers" style="height: 22px;font-size:11px;display: flex;justify-content:space-between"
                                                            :title="(T(`Schedule.plan_circuit_nurse`)+`：`+(room.room_setting.circuit_nurse || `--`)) +`；`+ (T(`Schedule.plan_equipment_nurse`)+`：`+(room.room_setting.equipment_nurse || `--`))">
                                                        <el-col
                                                                :style="{
                                                                    'text-align': `left`,
                                                                    'white-space': `nowrap`,
                                                                    'overflow': `hidden`,
                                                                    'text-overflow': `ellipsis`,
                                                                    'width': (room.room_setting.circuit_nurse && room.room_setting.circuit_nurse.split(`,`) || []).length > 1 ? `80px` : `50px`
                                                                }"
                                                            class="line-height20"
                                                        >
                                                            {{room.room_setting.circuit_nurse}}
                                                        </el-col>
                                                        <el-col class="line-height20"
                                                                :style="{
                                                                    'text-align': `left`,
                                                                    'white-space': `nowrap`,
                                                                    'overflow': `hidden`,
                                                                    'text-overflow': `ellipsis`,
                                                                    'width': (room.room_setting.equipment_nurse && room.room_setting.equipment_nurse.split(`,`) || []).length > 1 ? `80px` : `50px`
                                                                }">
                                                            {{room.room_setting.equipment_nurse}}
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </draggable>
                                </div>
                            </draggable>
                        </ScrollPane>
                        <div v-else key="active_noscrollPane" style="position: relative; overflow: hidden; width: 100%; text-align: left">
                            <draggable
                                class="height-p100 padding-right20"
                                ref="draggablePanel"
                                v-model="operationRoom"
                                v-bind="{ group: { name: 'card', pull: false, put: false }, animation: 150, handle: '.el-icon-sort' }"
                                @change="exchangeRoom"
                            >
                                <div
                                    class="inline-block margin2 margin-none-v cursor-pointer room"
                                    style="min-width: 80px; position: relative"
                                    :class="{'is-close': !room.is_open, 'is-operating': room.is_operating, height50: !roomCardShowWorkers, height70: roomCardShowWorkers}"
                                    v-for="room in operationRoom"
                                    :key="room.id"
                                >
                                    <span class="el-icon-sort" v-show="active_room_id == room.id" style="position: absolute; z-index: 1000; color: var(--primary-color, #009688)"></span>
                                    <draggable v-bind="roomDragOption(room.is_open)" @add="ScheduleSurgeries($event, room)">
                                        <div @click="LoadActiveRoomData($event, room)" :class="{height50: !roomCardShowWorkers, height70: roomCardShowWorkers}">
                                            <el-row class="height-p100">
                                                <el-col :span="2" class="height-p100 title"> &nbsp; </el-col>
                                                <el-col
                                                    :span="22"
                                                    class="content padding5 padding-none-v height-p100"
                                                    :class="{ active: active_room_id == room.id || scrolling_in_id == room.id }"
                                                    :style="styleObject(active_room_id == room.id || scrolling_in_id == room.id, room.room_setting)"
                                                    @dragenter.native="dragInRoom($event, room.id)"
                                                    @dragover.native="dragover"
                                                    @dragleave.native="dragOutRoom"
                                                    @dragend.native="dragOutRoom"
                                                >
                                                    <el-row class="font-size10" @click="active_room_id = room.id" style="white-space: nowrap; height: 22px">
                                                        <el-col
                                                            :span="10"
                                                            class="line-height20"
                                                            v-if="isShowRejectCount == 0"
                                                            key="active_norejectCount"
                                                            :style="active_room_id == room.id ? 'padding-left:10px' : ''"
                                                        >
                                                            {{ room.done }}/{{ room.total }}
                                                        </el-col>
                                                        <el-col :span="10" class="line-height20" v-else key="active_rejectCount" :style="active_room_id == room.id ? 'padding-left:10px' : ''">
                                                            <!-- <span class="el-icon-sort" v-show="active_room_id == room.id"></span> {{ room.done }}/{{ room.total }} -->
                                                            <span>{{ room.done }}/{{ room.total }}/</span><span style="color: red">{{ room.rejectCount }}</span>
                                                        </el-col>
                                                        <el-col :span="14" class="line-height20 align-right">
                                                            <span style="font-size: 11px">
                                                                <i
                                                                    class="el-icon-message-solid"
                                                                    title="当前手术间未具备手术资格"
                                                                    @click.stop="loadCheckList(room)"
                                                                    v-show="room.room_setting && room.room_setting.check_result == '不合格'"
                                                                ></i>
                                                            </span>
                                                            <span style="font-size: 11px" @click.stop="loadSettingForm(room)" :class="{ hasSetting: room.room_setting }">
                                                                <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                                            </span>
                                                        </el-col>
                                                    </el-row>
                                                    <span class="align-center" style="white-space: nowrap; line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex">{{
                                                        room.name
                                                    }}</span>
                                                    <el-row v-if="roomCardShowWorkers" style="height: 22px;font-size:11px;display: flex;justify-content:space-between"
                                                            :title="(T(`Schedule.plan_circuit_nurse`)+`：`+(room.room_setting.circuit_nurse || `--`)) +`；`+ (T(`Schedule.plan_equipment_nurse`)+`：`+(room.room_setting.equipment_nurse || `--`))">
                                                        <el-col
                                                                :style="{
                                                                    'text-align': `left`,
                                                                    'white-space': `nowrap`,
                                                                    'overflow': `hidden`,
                                                                    'text-overflow': `ellipsis`,
                                                                    'width': (room.room_setting.circuit_nurse && room.room_setting.circuit_nurse.split(`,`) || []).length > 1 ? `80px` : `50px`
                                                                }"
                                                            class="line-height20"
                                                        >
                                                            {{room.room_setting.circuit_nurse}}
                                                        </el-col>
                                                        <el-col class="line-height20"
                                                                :style="{
                                                                    'text-align': `left`,
                                                                    'white-space': `nowrap`,
                                                                    'overflow': `hidden`,
                                                                    'text-overflow': `ellipsis`,
                                                                    'width': (room.room_setting.equipment_nurse && room.room_setting.equipment_nurse.split(`,`) || []).length > 1 ? `80px` : `50px`
                                                                }">
                                                            {{room.room_setting.equipment_nurse}}
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </draggable>
                                </div>
                            </draggable>
                        </div>
                    </el-col>
                    <el-col v-show="isShowScrollPane && isShowMoreRoom" :md="0.5" :xl="0.5" :class="{ height60: !roomCardShowWorkers, height70: roomCardShowWorkers, 'align-right': true}">
                        <i
                            style="line-height: 50px"
                            @mouseenter="startScroll($event, 'right')"
                            @mouseleave="endScroll"
                            @dragenter="startScroll($event, 'right')"
                            @dragover="dragover"
                            @dragleave="endScroll"
                            class="el-icon-caret-right more"
                        ></i>
                    </el-col>
                </el-row>
            </div>
            <template slot="plan_time2" slot-scope="{ row }">
                <div style="white-space: normal">
                    {{ $moment(row.plan_time).format(`HH:mm`) }}
                </div>
            </template>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            :title="row.surgery_status"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                            :style="{ height: isShowDiseases && isShowDiseases == '1' ? `110px` : `80px` }"
                        >
                            &nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left" :title="titleLabel(row)">
                        <div class="ellipsis">
                            <b>
                                <span class="circle fg-red borderd" v-show="row.is_reoperation">再</span>
                                <!-- {{ `${row.patient_name}(${row.sex || '--'} / ${row.age || '--'} / ${row.bed_no || '--'}床 / ${row.visit_no})` }} -->
                                {{ `${row.patient_name}(${row.sex || '--'}` }}
                                <i style="color: red !important">/</i>{{ ` ${row.age || '--'} ` }} <i style="color: red !important">/</i>{{ ` ${row.bed_no || '--'}床 ` }}
                                <i style="color: red !important">/</i>{{ ` ${row.visit_no || '--'}` }}<i style="color: red !important">/</i>{{ ` ${row.outpatient_no || '--'})` }}
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div v-show="isShowDiseases && isShowDiseases == '1'">
                            <b class="ellipsis">{{ row.diseases }}</b>
                        </div>
                  <div v-if="!proc_GetTipItemsSchedule || proc_GetTipItemsSchedule == '0'">
                            <el-tag
                                :style="{
                                    color: row.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                    borderColor: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >{{ row.surgery_type }}</el-tag
                            >
                            <!-- <el-tag style="color: #f56c6c; border-color: #f56c6c; background-color: white" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag> -->
                            <el-tag
                                :style="{
                                    color: row.enum_surgery_status >= 40 ? '#DFE2E7' : '#52b8d2',
                                    borderColor: row.enum_surgery_status == 40 ? '#DFE2E7' : '#52b8d2',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >{{ row.enum_surgery_status > 10 ? '已排' : '待排' }}</el-tag
                            >
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white; font-weight: bold" size="mini">{{
                                row.enum_visit_type == 1 ? '住院' : row.enum_visit_type == 2 ? '门诊' : '体检'
                            }}</el-tag>
                            <el-tag
                                :style="{ color: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', borderColor: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini"
                                >日间</el-tag
                            >
                            <el-tag
                                :style="{ color: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', borderColor: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini"
                                >内镜</el-tag
                            >
                            <el-tag
                                :style="{
                                    color: row.infectious && row.infectious != '无' && row.infectious != 'NONE' && row.infectious != '未查' && row.infectious != 'NoCheck' ? 'red' : '#DFE2E7',
                                    borderColor: row.infectious ? '#f2b04b' : '#DFE2E7',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >传染病</el-tag
                            >
                            <el-tag
                                :style="{
                                    color: row.is_local_anes && row.is_local_anes == true ? '#5AA7B0' : '#DFE2E7',
                                    borderColor: row.is_local_anes ? '#5AA7B0' : '#DFE2E7',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >局麻
                            </el-tag>
                        </div>
                        <div v-else>
                            <el-tag v-for="item in row.patientInfoTipItemsList" :index="item.label" :key="item.label" :style="item.style" :title="item.title" size="mini">{{ item.label }}</el-tag>
                        </div>
                    </el-col>
                </el-row>
             </template>
            <template slot="push_status" slot-scope="{ row }">
                <i v-if="row.push_status == 1" class="el-icon-circle-check fg-primary"> </i>
                <i v-else-if="row.push_status == 2" class="el-icon-circle-check-outline fg-warning" :title="row.push_status_msg"></i>
                <i v-else-if="row.push_status == 3" class="el-icon-circle-close fg-danger" :title="row.push_status_msg"></i>
                <i v-else> </i>
            </template>
            <template slot="diseases" slot-scope="{ row }">
                <div style="min-width: 180px; white-space: normal">
                    <span>{{ row.diseases }}</span>
                </div>
            </template>
            <template slot="surgeries" slot-scope="{ row }">
                <div style="min-width: 180px; white-space: normal">
                    <span>{{ row.surgeries }}</span>
                </div>
            </template>
            <template slot="anaes_methods" slot-scope="{ row }">
                <div style="white-space: normal" :title="row.anaes_methods">
                    <b class="ellipsis">{{ row.anaes_methods }}</b>
                    <div class="fg-info ellipsis">{{ row.relation_text }}</div>
                </div>
            </template>
            <template slot="dic_section" slot-scope="{ row }">
                <div style="min-width: 100px; white-space: normal">
                    <span>{{ row.dic_section }}</span>
                </div>
            </template>
            <template slot="surgeon" slot-scope="{ row }">
                <!-- <el-popover ref="popover" trigger="hover" @show="showPhoto(row)"><img style="width: 200px; height: 200px" :src="row.worker_photo" /> </el-popover> -->
                <div style="min-width: 90px; white-space: normal">
                    <span>{{ row.surgeon && `(主)${row.surgeon}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
                <el-popover ref="popover" trigger="hover" @show="showPhoto(row)"><img style="width: 200px; height: 200px" :src="row.worker_photo" /> </el-popover>
                <img class="workerImg" v-show="isShowWorkerPhoto && row.surgeon_id && row.surgeon_photo" v-popover:popover :src="workerIcon" />
            </template>

            <template slot="remark" slot-scope="{ row }">
                <div style="white-space: normal">
                    <div class="fg-info">{{ row.his_remark }}</div>
                    <b>{{ row.remark }}</b>
                </div>
            </template>
        </crud-facecade>
        <crud-facecade
            ref="surgery-list"
            :key="2"
            :tableStyle="tableStyle"
            :tableHeight="tableHeight"
            :disableOrderDefaultSort="true"
            v-else
            :url="url2"
            :columns="columnList2"
            :customFixedColumns="customScheduleFixedColumns"
            :buttons="buttons"
            dialogWidth="80%"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :rowDropDisabled="false"
            :columnConfig="true"
            :showSequence="false"
            :selection="true"
            @loadSurgeryEditView="loadSurgeryEditView"
            @selectionChange="checkedRow"
            @rowContextMenu="rowContextMenu"
            :filterSpan="[15, 5, 6]"
            :stripe="scheduleSurgeryRowStyleConfig==`0`"
        >
            <slot slot="filter">
                <el-col :md="5" :xl="4" class="align-left">
                    <item-input type="datearraw2" v-model="scheduling_date" style="width: 160px"></item-input>
                </el-col>
                <el-col :md="10" :xl="10" class="align-left">
                    <el-button :type="isLoadToSchedule ? 'primary' : 'plain'" size="mini" @click="LoadUnScheduled()" title="待排程">
                        <span style="float: right; padding-right: 1px">待排程({{ unScheduledLength }})</span></el-button
                    >
                    <el-button :type="isLoadScheduled ? 'primary' : 'plain'" size="mini" @click="LoadAllScheduled()" title="已排程">
                        <span style="float: right; padding-right: 1px">已排程({{ ScheduledLength }})</span>
                    </el-button>
                    <el-button v-show="showCancelScheduledList" :type="isLoadCancelScheduled ? 'primary' : 'plain'" size="mini" @click="LoadCancelScheduled()" title="取消排程">
                        <span style="float: right; padding-right: 1px">取消排程({{ cancelScheduledLength }})</span>
                    </el-button>
                    <span title="已完成/未开始" style="font-weight: 600;">{{ScheduledLength1}}/<span :style="{ color: (ScheduledLength0 > 0) ? 'red' : 'black' }">{{ScheduledLength0}}</span></span>
                    <el-checkbox v-model="dataArea">全部</el-checkbox>
                </el-col>
                <el-col :md="3" :xl="3">
                    <item-input type="select" v-if="!IsHavePermission(`scheduling:CrossRegionScheduling`)" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                    <item-input type="multiselect" v-else v-model="dic_operating_ward_id_arr" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :md="3" :xl="2">
                    <item-input type="select" v-model="dic_section_id" :options="getsectionauth" :clearable="true" placeholder="请选择科室"></item-input>
                </el-col>
                <el-col :md="3" :xl="2">
                    <item-input type="select" v-model="selectsurgeryType" :options="surgeryTypes" placeholder="类型" @input="changed"></item-input>
                </el-col>
            </slot>

            <template slot="filter-after">
                <el-button type="primary" size="mini" v-has-permission="createapplyPermission" @click="openaddfrom()">创建手术</el-button>
                <el-button type="primary" v-show="this.surgeryinfopush == `true`" size="mini" @click="pushSchedule()" title="手术排程回传">排程回传<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="refreshList()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-dropdown @command="cancel">
                    <el-button type="primary" size="mini" v-show="isHaveCancelSchedule(`all`)">取消驳回<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cancelSchedule" v-show="isHaveCancelSchedule(`cancelSchedule`)">取消排程</el-dropdown-item>
                        <el-dropdown-item command="cancelSurgery" v-has-permission="cancelSurgeryPermission">取消手术</el-dropdown-item>
                        <el-dropdown-item command="rejectApprove" v-show="isHaveCancelSchedule(`rejectApprove`)">驳回审核</el-dropdown-item>
                        <el-dropdown-item command="rejectApply" v-show="isHaveCancelSchedule(`rejectApply`)">驳回申请</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="loadScheduleHelper">
                    <el-button type="primary" size="mini" v-show="ishavehelpSection(`all`)">排程助手<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="section" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpSection`)">按科室分配</el-dropdown-item>
                        <el-dropdown-item command="worker" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpWorker`)">按术者分配</el-dropdown-item>
                        <el-dropdown-item command="surgery" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpSurgery`)">按术式分配</el-dropdown-item>
                        <el-dropdown-item command="autoOneKeySchedule" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpOneKeySchedule`)">一键排程</el-dropdown-item>
                        <el-dropdown-item command="changeRoom" v-show="ishavehelpSection(`helpChangeRoom`)">更换手术间</el-dropdown-item>
                        <el-dropdown-item command="setAnesDoctor" v-show="ishavehelpSection(`helpSetAnesDoctor`)">设置麻醉医生</el-dropdown-item>
                        <el-dropdown-item command="clearWorkers">清除人员安排</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="printSurenry">
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in printSurgeryConfigs" :key="item.code" v-text="item.value" :command="item"></el-dropdown-item>
                        <!-- <el-dropdown-item command="PC008">打印手术信息</el-dropdown-item>
                        <el-dropdown-item command="PC009">打印首台通知</el-dropdown-item>
                        <el-dropdown-item command="PC007">打印排程列表</el-dropdown-item> -->
                        <el-dropdown-item command="ExportExcel">导出Excel</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <div ref="roomrow" slot="table-title">
                <el-row style="display: flex; align-items: center">
                    <el-col v-show="isShowScrollPane && isShowMoreRoom" :md="0.5" :xl="0.5" :class="{ height60: !roomCardShowWorkers, height70: roomCardShowWorkers, 'align-left': true}">
                        <i
                            style="line-height: 50px"
                            @mouseenter="startScroll($event, 'left')"
                            @mouseleave="endScroll"
                            class="el-icon-caret-left more"
                            @dragenter="startScroll($event, 'left')"
                            @dragover="dragover"
                            @dragleave="endScroll"
                        ></i>
                    </el-col>
                    <el-col :md="23" :xl="23" class="align-left" :class="{ height60: isShowScrollPane && !roomCardShowWorkers, height70: isShowScrollPane &&  roomCardShowWorkers}">
                        <ScrollPane v-if="isShowScrollPane" key="scrollpane" class="height-p100" ref="scrollpaneRef">
                            <draggable
                                class="height-p100 padding-right20"
                                ref="draggablePanel"
                                v-model="operationRoom"
                                v-bind="{ group: { name: 'card', pull: false, put: false }, animation: 150, handle: '.el-icon-sort' }"
                                @change="exchangeRoom"
                            >
                                <div
                                    class="height50 inline-block margin2 margin-none-v cursor-pointer room"
                                    style="min-width: 80px"
                                    v-for="room in operationRoom"
                                    :key="room.id"
                                    :class="{'is-close': !room.is_open, 'is-operating': room.is_operating, height50: !roomCardShowWorkers, height70: roomCardShowWorkers}"
                                >
                                    <draggable v-bind="roomDragOption(room.is_open)" @add="ScheduleSurgeries($event, room)">
                                        <div @click="LoadActiveRoomData($event, room)" :class="{height50: !roomCardShowWorkers, height70: roomCardShowWorkers}">
                                            <el-row class="height-p100">
                                                <el-col :span="2" class="height-p100 title"> &nbsp; </el-col>

                                                <el-col
                                                    :span="22"
                                                    class="content padding5 padding-none-v height-p100"
                                                    :class="{ active: active_room_id == room.id || scrolling_in_id == room.id }"
                                                    :style="styleObject(active_room_id == room.id || scrolling_in_id == room.id, room.room_setting)"
                                                    @dragenter.native.stop="dragInRoom($event, room.id)"
                                                    @dragleave.native.stop="dragOutRoom"
                                                    @dragover.native="dragover"
                                                    @dragend.native="dragOutRoom"
                                                >
                                                    <el-row class="font-size10" @click="active_room_id = room.id" style="height: 22px">
                                                        <el-col :span="10" class="line-height20" v-if="isShowRejectCount == 0" key="norejectCount">
                                                            <span class="el-icon-sort" v-show="active_room_id == room.id"></span> {{ room.done }}/{{ room.total }}
                                                        </el-col>
                                                        <el-col :span="10" class="line-height20" v-else key="rejectCount">
                                                            <span class="el-icon-sort" v-show="active_room_id == room.id"></span> <span>{{ room.done }}/{{ room.total }}/</span
                                                            ><span style="color: red">{{ room.rejectCount }}</span>
                                                        </el-col>
                                                        <el-col :span="14" class="line-height20 align-right">
                                                            <span style="font-size: 11px">
                                                                <i
                                                                    class="el-icon-message-solid"
                                                                    title="当前手术间未具备手术资格"
                                                                    @click.stop="loadCheckList(room)"
                                                                    v-show="room.room_setting && room.room_setting.check_result == '不合格'"
                                                                ></i>
                                                            </span>
                                                            <span style="font-size: 11px" @click.stop="loadSettingForm(room)" :class="{ hasSetting: room.room_setting }">
                                                                <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                                            </span>
                                                        </el-col>
                                                    </el-row>
                                                    <span class="align-center" style="white-space: nowrap; line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex">{{
                                                        room.name
                                                    }}</span>
                                                    <el-row v-if="roomCardShowWorkers" style="height: 22px;font-size:11px;display: flex;justify-content:space-between"
                                                            :title="(T(`Schedule.plan_circuit_nurse`)+`：`+(room.room_setting.circuit_nurse || `--`)) +`；`+ (T(`Schedule.plan_equipment_nurse`)+`：`+(room.room_setting.equipment_nurse || `--`))">
                                                        <el-col
                                                                :style="{
                                                                    'text-align': `left`,
                                                                    'white-space': `nowrap`,
                                                                    'overflow': `hidden`,
                                                                    'text-overflow': `ellipsis`,
                                                                    'width': (room.room_setting.circuit_nurse && room.room_setting.circuit_nurse.split(`,`) || []).length > 1 ? `80px` : `50px`
                                                                }"
                                                            class="line-height20"
                                                        >
                                                            {{room.room_setting.circuit_nurse}}
                                                        </el-col>
                                                        <el-col class="line-height20"
                                                                :style="{
                                                                    'text-align': `left`,
                                                                    'white-space': `nowrap`,
                                                                    'overflow': `hidden`,
                                                                    'text-overflow': `ellipsis`,
                                                                    'width': (room.room_setting.equipment_nurse && room.room_setting.equipment_nurse.split(`,`) || []).length > 1 ? `80px` : `50px`
                                                                }">
                                                            {{room.room_setting.equipment_nurse}}
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </draggable>
                                </div>
                            </draggable>
                        </ScrollPane>
                        <div v-else key="noscrollpane" style="position: relative; overflow: hidden; width: 100%; text-align: left">
                            <draggable
                                class="height-p100 padding-right20"
                                style="position: relative; overflow: hidden; width: 100%; text-align: left"
                                ref="draggablePanel"
                                v-model="operationRoom"
                                v-bind="{ group: { name: 'card', pull: false, put: false }, animation: 150, handle: '.el-icon-sort' }"
                                @change="exchangeRoom"
                            >
                                <div>
                                    <div
                                        class="height50 inline-block margin2 margin-none-v cursor-pointer room"
                                        style="min-width: 80px"
                                        :class="{ 'is-close': !room.is_open, 'is-operating': room.is_operating, height50: !roomCardShowWorkers, height70: roomCardShowWorkers }"
                                        v-for="room in operationRoom"
                                        :key="room.id"
                                    >
                                        <draggable v-bind="roomDragOption(room.is_open)" @add="ScheduleSurgeries($event, room)">
                                            <div @click="LoadActiveRoomData($event, room)" :class="{height50: !roomCardShowWorkers, height70: roomCardShowWorkers, active: true}">
                                                <el-row class="height-p100">
                                                    <el-col :span="2" class="height-p100 title"> &nbsp; </el-col>
                                                    <el-col
                                                        :span="22"
                                                        class="content padding5 padding-none-v height-p100"
                                                        :class="{ active: active_room_id == room.id || scrolling_in_id == room.id }"
                                                        :style="styleObject(active_room_id == room.id || scrolling_in_id == room.id, room.room_setting)"
                                                        @dragenter.native="dragInRoom($event, room.id)"
                                                        @dragover.native="dragover"
                                                        @dragleave.native="dragOutRoom"
                                                        @dragend.native="dragOutRoom"
                                                    >
                                                        <el-row class="font-size10" @click="active_room_id = room.id" style="white-space: nowrap; height: 22px">
                                                            <el-col :span="10" class="line-height20" v-if="isShowRejectCount == 0" key="noscroll_norejectCount">
                                                                <span class="el-icon-sort" v-show="active_room_id == room.id"></span> {{ room.done }}/{{ room.total }}
                                                            </el-col>
                                                            <el-col :span="10" class="line-height20" v-else key="noscroll_rejectCount">
                                                                <span class="el-icon-sort" v-show="active_room_id == room.id"></span> <span>{{ room.done }}/{{ room.total }}/</span
                                                                ><span style="color: red">{{ room.rejectCount }}</span>
                                                            </el-col>
                                                            <el-col :span="14" class="line-height20 align-right">
                                                                <span style="font-size: 11px">
                                                                    <i
                                                                        class="el-icon-message-solid"
                                                                        title="当前手术间未具备手术资格"
                                                                        @click.stop="loadCheckList(room)"
                                                                        v-show="room.room_setting && room.room_setting.check_result == '不合格'"
                                                                    ></i>
                                                                </span>
                                                                <span style="font-size: 11px" @click.stop="loadSettingForm(room)" :class="{ hasSetting: room.room_setting }">
                                                                    <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                                                </span>
                                                            </el-col>
                                                        </el-row>
                                                        <span class="align-center" style="white-space: nowrap; line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex">{{
                                                            room.name
                                                        }}</span>
                                                        <el-row v-if="roomCardShowWorkers" style="height: 22px;font-size:11px;display: flex;justify-content:space-between"
                                                            :title="(T(`Schedule.plan_circuit_nurse`)+`：`+(room.room_setting.circuit_nurse || `--`)) +`；`+ (T(`Schedule.plan_equipment_nurse`)+`：`+(room.room_setting.equipment_nurse || `--`))"
                                                        >
                                                            <el-col
                                                                :style="{
                                                                    'text-align': `left`,
                                                                    'white-space': `nowrap`,
                                                                    'overflow': `hidden`,
                                                                    'text-overflow': `ellipsis`,
                                                                    'width': (room.room_setting.circuit_nurse && room.room_setting.circuit_nurse.split(`,`) || []).length > 1 ? `80px` : `50px`
                                                                }"
                                                                class="line-height20"
                                                            >
                                                                {{room.room_setting.circuit_nurse}}
                                                            </el-col>
                                                            <el-col class="line-height20"
                                                                :style="{
                                                                    'text-align': `left`,
                                                                    'white-space': `nowrap`,
                                                                    'overflow': `hidden`,
                                                                    'text-overflow': `ellipsis`,
                                                                    'width': (room.room_setting.equipment_nurse && room.room_setting.equipment_nurse.split(`,`) || []).length > 1 ? `80px` : `50px`
                                                                }">
                                                                {{room.room_setting.equipment_nurse}}
                                                            </el-col>
                                                        </el-row>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </draggable>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </el-col>
                    <el-col v-show="isShowScrollPane && isShowMoreRoom" :md="0.5" :xl="0.5" :class="{ height60: !roomCardShowWorkers, height70: roomCardShowWorkers, 'align-right': true}">
                        <i
                            style="line-height: 50px"
                            @mouseenter="startScroll($event, 'right')"
                            @mouseleave="endScroll"
                            @dragenter="startScroll($event, 'right')"
                            @dragover="dragover"
                            @dragleave="endScroll"
                            class="el-icon-caret-right more"
                        ></i>
                    </el-col>
                </el-row>
            </div>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            :title="row.surgery_status"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                            :style="{ height: isShowDiseases && isShowDiseases == '1' ? `110px` : `80px` }"
                        >
                            &nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left" :title="titleLabel(row)">
                        <div class="ellipsis">
                            <b>
                                <span class="circle fg-red borderd" v-show="row.is_reoperation">再</span>
                                <!-- {{ `${row.patient_name}(${row.sex || '--'} / ${row.age || '--'} / ${row.bed_no || '--'}床 / ${row.visit_no})` }} -->
                                {{ `${row.patient_name}(${row.sex || '--'}` }}
                                <i style="color: red !important">/</i>{{ ` ${row.age || '--'} ` }} <i style="color: red !important">/</i>{{ ` ${row.bed_no || '--'}床 ` }}
                                <i style="color: red !important">/</i>{{ ` ${row.visit_no || '--'}` }}<i style="color: red !important">/</i>{{ ` ${row.outpatient_no || '--'})` }}
                            </b>
                            <b>
                                <span v-show="isChecked(row) != ''" class="circle fg-red borderd surgery-num-tag">{{ isChecked(row) }}</span>
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div v-show="isShowDiseases && isShowDiseases == '1'">
                            <b class="ellipsis">{{ row.diseases }}</b>
                        </div>
                  <div v-if="!proc_GetTipItemsSchedule || proc_GetTipItemsSchedule == '0'">
                            <el-tag
                                :style="{
                                    color: row.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                    borderColor: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >{{ row.surgery_type }}</el-tag
                            >
                            <!-- <el-tag style="color: #f56c6c; border-color: #f56c6c; background-color: white" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag> -->
                            <el-tag
                                :style="{
                                    color: row.enum_surgery_status >= 40 ? '#DFE2E7' : '#52b8d2',
                                    borderColor: row.enum_surgery_status == 40 ? '#DFE2E7' : '#52b8d2',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >{{ row.enum_surgery_status > 10 ? '已排' : '待排' }}</el-tag
                            >
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white; font-weight: bold" size="mini">{{
                                row.enum_visit_type == 1 ? '住院' : row.enum_visit_type == 2 ? '门诊' : '体检'
                            }}</el-tag>
                            <el-tag
                                :style="{ color: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', borderColor: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini"
                                >日间</el-tag
                            >
                            <el-tag
                                :style="{ color: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', borderColor: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini"
                                >内镜</el-tag
                            >
                            <el-tag
                                :style="{
                                    color: row.infectious && row.infectious != '无' && row.infectious != 'NONE' && row.infectious != '未查' && row.infectious != 'NoCheck' ? 'red' : '#DFE2E7',
                                    borderColor: row.infectious ? '#f2b04b' : '#DFE2E7',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >传染病</el-tag
                            >
                            <el-tag
                                :style="{
                                    color: row.is_local_anes && row.is_local_anes == true ? '#5AA7B0' : '#DFE2E7',
                                    borderColor: row.is_local_anes ? '#5AA7B0' : '#DFE2E7',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >局麻
                            </el-tag>
                        </div>
                        <div v-else>
                            <span v-for="item in row.patientInfoTipItemsList" :index="item.label" :key="item.label">
                                <el-tag :style="item.style" :title="item.title" size="mini">{{ item.label }}</el-tag
                                >&nbsp;
                            </span>
                        </div>
                    </el-col>
                </el-row>
            </template>
             <template slot="dic_operating_room" slot-scope="{ row }">
                   <el-input type="select" v-model="row.dic_operating_room" @click.native="openRoomSelect(row)" :options="[]" placeholder=""></el-input>
            </template>
            <template slot="plan_time2" slot-scope="{ row }">
                <div style="white-space: normal">
                    {{ $moment(row.plan_time).format(`HH:mm`) }}
                </div>
            </template>
            <template slot="push_status" slot-scope="{ row }">
                <i v-if="row.push_status == 1" class="el-icon-circle-check fg-primary"> </i>
                <i v-else-if="row.push_status == 2" class="el-icon-circle-check-outline fg-warning" :title="row.push_status_msg"></i>
                <i v-else-if="row.push_status == 3" class="el-icon-circle-close fg-danger" :title="row.push_status_msg"></i>
                <i v-else> </i>
            </template>
            <template slot="diseases" slot-scope="{ row }">
                <div style="min-width: 180px; white-space: normal">
                    <span>{{ row.diseases }}</span>
                </div>
            </template>
             <template slot="surgeries" slot-scope="{ row }">
                <div style="min-width: 180px; white-space: normal">
                    <span>{{ row.surgeries }}</span>
                </div>
            </template>
            <template slot="anaes_methods" slot-scope="{ row }">
                <div style="white-space: normal" :title="row.anaes_methods">
                    <b class="ellipsis">{{ row.anaes_methods }}</b>
                    <div class="fg-info ellipsis">{{ row.relation_text }}</div>
                </div>
            </template>
            <template slot="dic_section" slot-scope="{ row }">
                <div style="min-width: 100px; white-space: normal">
                    <span>{{ row.dic_section }}</span>
                </div>
            </template>
            <template slot="surgeon" slot-scope="{ row }">
                <div style="min-width: 90px; white-space: normal">
                    <span>{{ row.surgeon && `(主)${row.surgeon}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
                <el-popover ref="popover1" trigger="hover" @show="showPhoto(row)"> <img style="width: 200px; height: 200px" :src="row.worker_photo" /> </el-popover>
                <img class="workerImg" v-show="isShowWorkerPhoto && row.surgeon_id && row.surgeon_photo" v-popover:popover1 :src="workerIcon" />
            </template>
            <template slot="remark" slot-scope="{ row }">
                <div style="white-space: normal">
                    <div class="fg-info">{{ row.his_remark }}</div>
                    <b>{{ row.remark }}</b>
                </div>
            </template>

        </crud-facecade>
        <el-dialog :title="autoScheduleTitle" :close-on-click-modal="false" :visible.sync="autoScheduleVisible" class="table-h560" width="90%">
            <ListView :datalist="autoScheduleSurgeries" :columns="autoScheduleColumnListBand" :buttons="autoScheduleButtons" @extrabutton-click="ExtraButtonClick"></ListView>
            <span slot="footer" class="dialog-footer">
                <el-button @click="autoScheduleVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAutoSchedule">确 定</el-button>
            </span>
        </el-dialog>
        <cus-dialog :title="printSurenryForm.title" :visible.sync="printSurenryForm.dialogFormVisible" width="30%" @confirm="printSurenryByTime()">
            <div class="margin10 margin-none-h align-left" v-if="printSurenryForm.type == 4">
                <item-input type="multiselect" :showCount="3" :collapseTags="false" v-model="printSurenryForm.wardids" :options="operation_ward_auth" placeholder="请选择手术区"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left" v-if="printSurenryForm.type == 3">
                请选择手术间：<item-input style="width: 150px" type="multiselect" v-model="printSurenryForm.roomids" :options="printSurenryForm.rooms" placeholder="请选择手术间"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left">
                请 指 定 时 间：<item-input style="width: 300px" v-if="printSurenryForm.type == 5" type="datetimerange" v-model="printSurenryForm.from_to" :noPadding="true"></item-input>
                <item-input style="width: 300px" v-else type="daterange" v-model="printSurenryForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
        <form-dialog
            :title="roomSettings.title"
            :data="roomSettings.data"
            width="40%"
            :visible.sync="roomSettings.dialogFormVisible"
            :columns="roomSettingsColumns"
            :buttons="roomSettings.buttons"
            @confirm="saveSettings"
        ></form-dialog>
        <form-dialog
            :title="changeRoom.title"
            :data="changeRoom.data"
            width="40%"
            :visible.sync="changeRoom.dialogFormVisible"
            :columns="changeRoom.changeRoomColumns"
            @confirm="changeRoomSave"
        ></form-dialog>
        <form-dialog
            :title="setAnesDoctor.title"
            :data="setAnesDoctor.data"
            width="40%"
            :visible.sync="setAnesDoctor.dialogFormVisible"
            :columns="setAnesDoctor.setAnesDoctorColumns"
            @confirm="setAnesDoctorSave"
        ></form-dialog>
        <cus-dialog :title="clearWorkers.title" :visible.sync="clearWorkers.dialogFormVisible" width="40%" @confirm="setClearWorkersSave">
            <el-row>
                <el-col :span="24" style="line-height: 35px">
                    <label style="float: left;">角色：</label>
                    <item-input style="width: 80%; float: left;"
                        type="checkboxgroup"
                        v-model="clearWorkers.workerDuties"
                        :options="[
                            { value: `3`, label: `麻醉医生` },
                            { value: `4`, label: `麻醉助手` },
                            { value: `5`, label: `巡回护士` },
                            { value: `6`, label: `器械护士` }
                        ]"
                    ></item-input>
                </el-col>
            </el-row>
        </cus-dialog>
        <EditSurgery :surgeryId="edit.surgeryId" :editButtons="editButtons" :visible.sync="edit.dialogFormVisible" @after-save="afterSave" @save="refreshList"></EditSurgery>
        <cus-dialog :title="docinfo.title" :visible.sync="dialogFormVisible1" :footerVisible="false" width="60%" class="dialog-adverse">
            <el-row>
                <el-col :span="24" class="align-right">
                    <label style="line-height: 35px">核对人：</label>
                    <item-input
                        class="block-multi-collapse-select-width"
                        :collapseTags="true"
                        style="width: 180px"
                        type="select"
                        v-model="active_item.check_user_id"
                        :options="this.roomssettingWorkers[`护士`]"
                        placeholder="核对人"
                    ></item-input>
                    <label style="padding-left: 30px; line-height: 35px">记录时间:</label>
                    <item-input
                        style="width: 180px"
                        :collapseTags="true"
                        :noPadding="true"
                        datetimeFormate="yyyy/MM/dd HH:mm"
                        type="datetime"
                        v-model="active_item.check_date"
                        placeholder="记录时间"
                    ></item-input>
                    <span style="padding-left: 30px">
                        <el-button type="primary" size="mini" plain @click="SaveChanges('合格')" style="margin-left: unset !important">核对通过</el-button>
                        <el-button type="primary" size="mini" plain @click="SaveChanges('不合格')" style="margin-left: unset !important">核对不通过</el-button>
                    </span>
                </el-col>
            </el-row>
            <DocFrame
                ref="doc"
                :guid="`checklist_${this.active_item.dic_operating_room_id}_${this.active_item.date}_SSJJC001`"
                :docno="this.$root.DOCUMENT && this.$root.DOCUMENT.SSJJC001"
                :surgeryId="0"
                @saved="afterDocSaved"
                :docname="docinfo.title"
            ></DocFrame>
        </cus-dialog>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="saveOverrule"></form-dialog>
        <form-dialog
            :title="exportExcel.title"
            :data="exportExcel.data"
            width="40%"
            :visible.sync="exportExcel.dialogFormVisible"
            :columns="exportExcel.Columns"
            @confirm="exportExcelSave"
        ></form-dialog>
        <AddSurgery :visible.sync="addfrom.dialogFormVisible" :defaultplanTime="addfrom.defaultplanTime" @afteradd="afteradd"> </AddSurgery>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import EditSurgery from './EditSurgery.vue'
import AddSurgery from './AddSurgery.vue'
export default {
    name: `ScheduleSurgery`,
    components: { draggable, EditSurgery, AddSurgery },
    props: {},
    data() {
        let validateLength = (rule, value, callback) => {
            if (this.rejectReasons && this.rejectReasons.length > 0) {
                if (value && value.trim().length < 2) {
                    callback(new Error(`驳回理由不能少于2个字符`))
                } else {
                    callback()
                }
            } else {
                if (value && value.trim().length < 4) {
                    callback(new Error(`驳回理由不能少于4个字符`))
                } else {
                    callback()
                }
            }
        }
        let offset = (this.$root.ScheduleQueryDateOffset || ``).split(`,`)
        let firstOffSetDate = 1
        if (offset && offset.length == 3) {
            firstOffSetDate = offset[0] // 排程日期
        }
        // 读取暂存的查询条件
        let schedulingCondition = sessionStorage.getItem(`consd`)
        let sessionSchedulingDate = this.$moment()
            .add(firstOffSetDate, `days`)
            .format(`YYYY/MM/DD 00:00:00`)
        let sessionDataArea = false
        let sessionIsLoadToSchedule = null
        let sessionIsLoadScheduled = null
        let sessionIsLoadCancelScheduled = null
        let sessionDicOperatingWardId = 0
        let sessionDicOperatingWardIdArr = []
        let sessionSelectsurgeryType = null
        let sessionActiveRoomId = 0
        if (schedulingCondition && JSON.parse(schedulingCondition) != null) {
            var obj = JSON.parse(schedulingCondition)
            sessionSchedulingDate = obj.scheduling_date
            sessionDataArea = obj.dataArea
            sessionIsLoadToSchedule = obj.isLoadToSchedule
            sessionIsLoadScheduled = obj.isLoadScheduled
            sessionIsLoadCancelScheduled = obj.isLoadCancelScheduled
            sessionDicOperatingWardId = obj.dic_operating_ward_id
            sessionDicOperatingWardIdArr = obj.dic_operating_ward_id_arr
            sessionSelectsurgeryType = obj.selectsurgeryType
            sessionActiveRoomId = obj.active_room_id
            this.$nextTick(() => {
                if (this.$refs[`surgery-list`]) {
                    this.$refs[`surgery-list`].searchValue = obj.searchValue != null ? obj.searchValue : ``
                }
            })
        }
        return {
            lastalertmsg: ``,
            title: `手术排程`,
            roomStyle: {
                color: ``,
                backgroundColor: ``,
                fontSize: ``,
                activecolor: ``,
                activebackgroundColor: ``,
                activefontSize: ``,
                isEnable: `0`, // 是否启用人员配置背景色
                bgColor: ``, // 人员配置对应背景色展示
                activebgColor: `` // 人员配置对应手术间选中时背景色展示
            },
            rejectReasons: [],
            printSurgeryConfigs: [],
            overrule: {
                title: `手术驳回`,
                dialogFormVisible: false,
                emitBtnName: ``,
                data: {},
                columns: [
                    {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `驳回原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons,
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ]
            },
            addfrom: {
                dialogFormVisible: false,
                defaultplanTime: this.$moment(this.rdate).format(`YYYY/MM/DD 08:00:00`)
            },
            surgeryIds: [],
            AutoOneKeyScheduleMsg: this.$root.AutoOneKeyScheduleMsg,
            isShowRejectCount: this.$root.IsShowRejectCount,
            surgeryinfopush: this.$root.SurgeryInfoPush,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            ScheduleRoomStyleSetting: this.$root.ScheduleRoomStyleSetting,
            ScheduleNurseFilterSection: this.$root.ScheduleNurseFilterSection,
            settingRoomBgColor: this.$root.settingRoomBgColor,
            scheduleSurgeryStyle: this.$root.ScheduleSurgeryStyle,
            isAutoScheduledSequence: this.$root.IsAutoScheduledSequence,
            thistableHeight: 0,
            isLoadToSchedule: schedulingCondition ? sessionIsLoadToSchedule : true, // 默认选中待排程卡片
            isLoadScheduled: schedulingCondition ? sessionIsLoadScheduled : true, // 已排程卡片
            isLoadCancelScheduled: schedulingCondition ? sessionIsLoadCancelScheduled : false, // 已排程卡片
            isEnableFilterStatusForExportExcel: this.$root.IsEnableFilterStatusForExportExcel, // 是否开启导出Excel 按状态过滤数据
            unschedule_list: [], // 待排程列表
            unScheduledLength: 0, // 待排程数量
            ScheduledLength: 0, // 已排程数量
            ScheduledLength0: 0, // 已排程未开始
            ScheduledLength1: 0, // 已进行手术
            scheduled_list: [], // 已排程列表
            cancelScheduledLength: 0,
            cancelSchedule_list: [],
            activeRoomScheduled_list: [], // 手术间已排程列表
            docinfo: { title: `手术间检查单`, docbizid: 0 },
            dialogFormVisible1: false,
            active_item: {
                id: 0,
                date: null,
                dic_operating_room_id: 0,
                operating_ward: ``,
                operating_room: ``,
                check_user: {},
                check_user_id: 0,
                check_date: new Date()
            },
            scheduling_date: schedulingCondition
                ? sessionSchedulingDate
                : this.$moment()
                    .add(firstOffSetDate, `days`)
                    .format(`YYYY/MM/DD 00:00:00`), // 排程日期
            o_dic_operating_ward_id: schedulingCondition ? sessionDicOperatingWardId : undefined, // 排程手术区
            o_dic_operating_ward_id_arr: schedulingCondition ? sessionDicOperatingWardIdArr : [], // 排程手术区
            o_dic_section_id: ``,
            dic_section_arr: [],
            issetoperatingward: false,
            active_room_id: schedulingCondition ? sessionActiveRoomId : 0, // 当前手术间Id
            scheduling_way: 1, // 排程助手  1=按科室 2=按术者 3=按术式
            url2: {
                // 待排程和已排程，调用
                area: `schedule_surgery`,
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    if (this.active_room_id > 0) {
                        return []
                    } else {
                        return this.loadUnScheduledAndScheduled()
                    }
                },
                putMany: data => {
                    let that = this
                    that.putScheduled(data)
                }
            },
            url: {
                // 手术间视图卡片
                area: `schedule_surgery`,
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    if (this.active_room_id == 0) {
                        return []
                    } else {
                        return this.loadActiveRoomScheduled()
                    }
                },
                putMany: data => {
                    let that = this
                    // isAutoScheduledSequence=0，校验台次是否重复
                    if (that.isAutoScheduledSequence == `0`) {
                        let checksequence = _.filter(data, d => {
                            return d.scheduled_sequence != null
                        })
                        console.log(checksequence)
                        return new Promise(resolve => {
                            let req = that.myaxios.put(`/api/Preoperative/Schedule/CheckSequence?date=${that.scheduling_date}`, checksequence)
                            req.then(d => {
                                if (d && d != ``) {
                                    this.$confirm(d, `提示`, {
                                        confirmButtonText: `确定`,
                                        cancelButtonText: `取消`,
                                        type: `warning`,
                                        closeOnClickModal: false
                                    })
                                        .then(() => {
                                            that.putScheduled(data)
                                        })
                                        .catch(e => {})
                                } else {
                                    that.putScheduled(data)
                                }

                                resolve(d)
                            })
                        })
                    } else {
                        that.putScheduled(data)
                    }
                }
            },
            buttons: [],
            editButtons: [
                {
                    label: `确认排程`,
                    type: `default`,
                    permission: `ApplySurgery:ConfirmSchedule`
                }
            ],
            checkedRows: [],
            dataArea: schedulingCondition ? sessionDataArea : false,
            operation_ward_all: undefined,
            autoScheduleSurgeries: [],
            autoScheduleVisible: false,
            autoScheduleColumnListBand: [],
            createapplyPermission: `scheduling:createapply`, // 创建手术
            workerIcon: `../../static/img/avatar/default/surgeon_photo.png`,
            isShowWorkerPhoto: !!(this.$root.isShowWorkerPhoto && this.$root.isShowWorkerPhoto == `1`),
            autoScheduleButtons: [
                {
                    // class:"is-circle",
                    label: `移除`,
                    icon: ``,
                    type: `danger`,
                    emit: `cancelAutoSchedule`,
                    permission: `default`
                }
            ],
            autoScheduleColumnList: [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    sortable: true,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_ward`,
                    label: `手术区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    isListable: true
                },

                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`surgery_scheduling.visit_no`),
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgery_type`,
                    label: `手术类型`,
                    isListable: true,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true,
                    width: `140`
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    isListable: true,
                    width: `140`
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: this.T(`Schedule.plan_surgeon`),
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: this.T(`Schedule.plan_surgeon_assistants`),
                    isListable: true
                }
            ],
            autoScheduleUrl: { get: `/api/Preoperative/Schedule/GetAutoScheduleBySection` },
            roomSettings: {
                title: `手术间设置`,
                data: {},
                dialogFormVisible: false,
                columns: [],
                buttons: [
                    {
                        label: `应用人员`,
                        type: `primary`,
                        permission: `scheduling:yyry`
                    }
                ]
            },
            printSurenryForm: {
                dialogFormVisible: false,
                from_to: [],
                code: ``,
                type: 0,
                roomids: null,
                extradata: null,
                rooms: [],
                wardids: null,
                title: `日期区间打印`
            },
            changeRoom: {
                title: `更换手术间`, // ACIS-23414, 手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
                type: `change`,
                data: {},
                dialogFormVisible: false,
                changeRoomColumns: [
                    {
                        type: `select`,
                        prop: `dic_recovery_ward_id`,
                        label: `手术区`,
                        isListable: true,
                        isEditable: true,
                        isCreatable: true,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        options: (that, { row }) => {
                            let data = _.filter(this.operation_ward_auth_disabled, d => {
                                return d.disabled === false
                            })
                            if (!this.IsHavePermission(`scheduling:CrossRegionScheduling`)) {
                                data = _.filter(data, { value: this.dic_operating_ward_id })
                            }
                            return data
                        }
                    },
                    {
                        type: `select`,
                        prop: `dic_operating_room_id`,
                        label: `手术间`,
                        isListable: true,
                        isEditable: true,
                        isCreatable: true,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        options: (that, { row }) => {
                            let data = _.filter(this.operation_ward_auth_disabled, d => {
                                return d.value == row.dic_recovery_ward_id
                            })
                            return (
                                _.filter(data[0] && data[0].operation_room, d => {
                                    return d.disabled === false
                                }) || []
                            )
                        }
                    }
                ]
            },
            setAnesDoctor: {
                title: `设置麻醉医生`,
                data: {},
                dialogFormVisible: false,
                setAnesDoctorColumns: [
                    {
                        type: `remoteselect`,
                        prop: `plan_anes_doctor`,
                        label: this.T(`Schedule.plan_anes_doctor`),
                        isCreatable: true,
                        isEditable: true,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                                if (this.$root.UseASACheck == `1`) {
                                    works = works.map(d => {
                                        return {
                                            label: d.label,
                                            value: d.value,
                                            jianpin: d.jianpin,
                                            card_no: d.card_no,
                                            worker_duty: d.worker_duty,
                                            //  code: d.code,
                                            // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                            code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                        }
                                    })
                                }
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    }
                ]
            },
            clearWorkers: {
                title: `清除人员安排`,
                data: {},
                dialogFormVisible: false,
                workerDuties: []
            },
            edit: {
                dialogFormVisible: false,
                surgeryId: 0
            },
            exportExcel: {
                title: `导出数据过滤`, // ACIS-23414, 手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
                data: {},
                exportDatas: [],
                dialogFormVisible: false,
                Columns: [
                    {
                        type: `checkboxgroup`,
                        prop: `status`,
                        label: `状态:`,
                        options: [
                            { label: `已排程`, value: `已排程` },
                            { label: `进行中`, value: `进行中` },
                            { label: `手术结束`, value: `手术结束` },
                            { label: `苏醒中`, value: `苏醒中` },
                            { label: `苏醒结束`, value: `苏醒结束` }
                        ],
                        colspan: 24,
                        default: [`已排程`, `进行中`, `手术结束`, `苏醒中`, `苏醒结束`]
                    }
                ]
            },
            selectsurgeryType: schedulingCondition ? sessionSelectsurgeryType : 0,
            timer_interval: null,
            isShowDiseases: this.$root.IsShowDiseases,
            showCancelScheduledList: this.$root.ShowCancelScheduledList == `1`,
            cancelSurgeryPermission: `scheduling:cancel_surgery`, // 取消手术
            IntelligenceSurgeryPermission: `scheduling:intelligence`, // 排程助手按钮显示权限
            isShowScrollPane: this.$root.IsShowScheduleScroll == `true`,
            isShowMoreRoom: false,
            scrolling_in_id: 0, // 当前拖动操作的手术间Id
            dragEventTager: null, // 当前鼠标拖动触发的对象
            setIntervalScroll: {}, // 滚动定时器
            isShowInfectiousAlert: this.$root.IsShowInfectiousAlert,
            showSurgeryAlert: this.$root.proc_ShowSurgeryAlert,
            isShowInfectiousAlertConfigs: [],
            surgeryNameConfig: this.$root.SurgeryNameConfig,
            scheduleCustomOrder: this.$root.ScheduleCustomOrder,
            orderItems: [
                { orderName: `手术间`, orderField: `dic_operating_room_order` },
                { orderName: `麻醉方式`, orderField: `plan_anaes_methods` },
                { orderName: `麻醉医生`, orderField: `anes_doctor` },
                { orderName: `申请时间`, orderField: `apply_time` },
                { orderName: `科室`, orderField: `dic_section_order` },
                { orderName: `姓名`, orderField: `patient_name` },
                { orderName: `台次`, orderField: `scheduled_sequence_num` },
                { orderName: `计划手术时间`, orderField: `plan_time` },
                { orderName: `申请台次`, orderField: `sequence_apply` },
                { orderName: `手术医生`, orderField: `surgeon` },
                { orderName: `手术名称`, orderField: `surgeries` }
            ],
            proc_GetTipItemsSchedule: this.$root.proc_GetTipItemsSchedule,
            scheduleWorkerFilter: this.$root.ScheduleWorkerFilter || `0`,
            roomCardShowWorkers: this.$root.RoomCardShowWorkers && this.$root.RoomCardShowWorkers == `1`,
            scheduleSurgeryRowStyleConfig: this.$root.ScheduleSurgeryRowStyleConfig || `0`,
            scheduleSurgeryRowStyleObj: undefined,
            roomSettingWorkerConfig: this.$root.RoomSettingWorkerConfig == `1`,
            roomSelectVisible: false, // 弹层显隐
            selectableRooms: [], // 当天全部可选手术间
            selectedRoomId: null, // 当前选中手术间
            rowToAssign: null, // 当前要分配的行数据
            circuitNurseVisible: false, // 弹层显隐
            sugerydutyname: ``,
            nurseKeyword: ``, // 弹层内搜索字
            currentRow: null, // 当前行
            localSelectedNurses: [] // 弹层多选确定
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.loadRoomStyle()
        if (this.timer_interval) {
            window.clearInterval(this.timer_interval)
        }
        if (this.isShowInfectiousAlert && this.isShowInfectiousAlert.trim() != ``) {
            let config = JSON.parse(this.isShowInfectiousAlert)
            if (config && config.length > 0) {
                this.isShowInfectiousAlertConfigs = config.filter(d => {
                    return d.IsEnable && d.IsEnable == 1
                })
            }
        }
        if (this.scheduleSurgeryRowStyleConfig && this.scheduleSurgeryRowStyleConfig.trim() != `0`) {
            this.scheduleSurgeryRowStyleObj = eval(
                `(` + this.scheduleSurgeryRowStyleConfig + `)`
            )
        }
        this.lastalertmsg = ``
    },
    mounted() {
        this.ReloadRoom()
        this.loadRejectResons()
        this.loadPrintSurgeryConfig()
        if (!this.timer_interval && this.getSurgeryInfoSyncTime > 0) {
            // 开启定时器，定时获取手术
            this.timer()
        }
    },
    beforeRouteLeave(to, from, next) {
        let that = this
        if (that.$refs[`surgery-list`] && that.$refs[`surgery-list`].rowChanges.length > 0) {
            that.$confirm(`提示`, {
                title: `提示`,
                message: `有未保存项，请确认是否保存`,
                confirmButtonText: `确认`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                that.$refs[`surgery-list`] && that.$refs[`surgery-list`].SaveChanges().then(() => {
                    that.destroyed()
                    next()
                })
            }).catch(e => {
                that.destroyed()
                next()
            })
        } else {
            that.destroyed()
            next()
        }
    },
    computed: {
        ...mapGetters([
            `operation_ward`,
            `sysuser/workers_by_duty`,
            `surgery/anaesthesia_method`,
            `sysuser/workers_by_dutyNew`,
            `sys_enums`,
            `listview/remove_item`,
            `operation_ward_auth`,
            `operation_ward_auth_disabled`,
            `screenHeight`,
            `permissions`,
            `active_ward`,
            `section_auth`,
            `operation_room_auth`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        dic_operating_ward_id: {
            get: function() {
                // 读取暂存的查询条件
                let schedulingCondition = sessionStorage.getItem(`consd`)
                let wardid
                if (schedulingCondition && JSON.parse(schedulingCondition) != null) {
                    var obj = JSON.parse(schedulingCondition)
                    wardid = obj.dic_operating_ward_id
                    if (!this.issetoperatingward && wardid) {
                        this.o_dic_operating_ward_id = parseInt(wardid)
                    }
                } else if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        dic_operating_ward_id_arr: {
            get: function() {
                // 读取暂存的查询条件
                let schedulingCondition = sessionStorage.getItem(`consd`)
                if (schedulingCondition && JSON.parse(schedulingCondition) != null) {
                    var obj = JSON.parse(schedulingCondition)
                    let wardid = obj.dic_operating_ward_id_arr
                    if (!this.issetoperatingward && wardid && wardid.length > 0) {
                        this.o_dic_operating_ward_id_arr = wardid
                    }
                } else if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id_arr = [this.active_ward.origion]
                }
                return this.o_dic_operating_ward_id_arr
            },
            set: function(v) {
                this.o_dic_operating_ward_id_arr = v
                this.issetoperatingward = true
            }
        },
        surgeryTypes() {
            var r = _.map(this.sys_enums && this.sys_enums.Enum_SurgeryType, d => {
                return {
                    value: d.value,
                    label: d.label
                }
            })
            return [{ value: 0, label: `全部类型` }].concat(r)
        },
        dic_section_id: {
            get: function() {
                return this.o_dic_section_id
            },
            set: function(v) {
                this.o_dic_section_id = v
            }
        },
        roomssettingWorkers() {
            return this[`sysuser/workers_by_duty`]
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                console.log(`isWorkerByDuty==0,获取的医生`, this[`sysuser/workers_by_duty`])
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                console.log(`isWorkerByDuty==0,获取的巡回护士`)
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        getSurgeryInfoSyncTime() {
            let surgeryInfoSyncTime = 0
            if (this.$root.SurgeryInfoSyncTime && this.$root.SurgeryInfoSyncTime != 0 && this.$root.SurgeryInfoSyncTime != `0`) {
                let time = parseInt(this.$root.SurgeryInfoSyncTime)
                if (time && time > 0) {
                    surgeryInfoSyncTime = time * 60000 // 5分钟，5*60000
                }
            }
            return surgeryInfoSyncTime
        },
        IsCrossRegionScheduling() {
            return _.find(this.permissions, { no: `scheduling:CrossRegionScheduling` }) != undefined
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        },
        tableStyle() {
            return this.scheduleSurgeryStyle
        },
        tableHeight() {
            return (this.screenHeight && this.screenHeight - this.thistableHeight - 185) || 0
        },
        operationRoom: {
            get() {
                let that = this
                let r = []
                if (this.IsHavePermission(`scheduling:CrossRegionScheduling`)) {
                    that.dic_operating_ward_id_arr && that.dic_operating_ward_id_arr.forEach(wardId => {
                        let rooms = this.operation_ward_all && this.operation_ward_all[wardId]
                        let wardrooms = _.orderBy(rooms, `display_order`)
                        r = r.concat(wardrooms)
                    })
                } else {
                    r = this.operation_ward_all && this.operation_ward_all[this.dic_operating_ward_id]
                    r = _.orderBy(r, `display_order`) || []
                }
                // 不折行显示手术间时，当出现滚动条时 显示出 < 和>图标
                if (r && r.length > 0 && this.isShowScrollPane) {
                    setTimeout(() => {
                        that.$nextTick(() => {
                            if (that.$refs.scrollpaneRef && that.$refs.scrollpaneRef.$refs.scrollContainer.$refs.wrap && that.$refs.draggablePanel) {
                                let scrollbar = that.$refs.scrollpaneRef.$refs.scrollContainer.$refs.wrap
                                let roomPanel = that.$refs.draggablePanel
                                if (scrollbar.scrollWidth > roomPanel.$el.offsetWidth) {
                                    that.isShowMoreRoom = true
                                } else {
                                    that.isShowMoreRoom = false
                                }
                            }
                        })
                    }, 100)
                }
                return r
            },
            set() {}
        },
        activeRoom() {
            let r = _.find(this.operationRoom, { id: this.active_room_id })
            return r || { name: `待排程` }
        },
        columnList() {
            let me = this
            let listeditWorker = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:list_editWorker`) === -1
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    queryable: true,
                    sortable: true,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`surgery_scheduling.visit_no`),
                    queryable: true,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    queryable: true,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    queryable: true,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    queryable: true,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床位号`,
                    queryable: true,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `surgeries`,
                    label: `手术名称`,
                    queryable: true,
                    isListable: true,
                    width: `180`,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `patient_abbr`,
                    label: `患者姓名简拼`,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息卡`,
                    width: `350`,
                    isListable: true,
                    area: [1, 2],
                    tooltip: false
                },
                {
                    type: `string`,
                    prop: `infectious`,
                    label: `传染病`,
                    width: `350`,
                    isListable: true,
                    area: [1, 2],
                    tooltip: false,
                    sortable: true
                },
                {
                    type: `select`,
                    prop: `enum_surgery_status`,
                    label: `手术状态`,
                    isListable: true,
                    options: this.sys_enums.SurgeryStatus || [],
                    width: `100`,
                    readonly: true,
                    area: [1, 2],
                    sortable: true
                },
                {
                    type: `number`,
                    prop: `sequence`,
                    label: `申请台次`,
                    isListable: true,
                    width: `100`,
                    readonly: true,
                    area: [1, 2],
                    sortable: false
                },
                {
                    type: `selectAllowCreate`,
                    prop: `scheduled_sequence`,
                    allowCreate: true,
                    label: `台次`,
                    isListable: !this.$root.IsShowWithOperatingRoom || this.$root.IsShowWithOperatingRoom == `0`,
                    width: `100`,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    area: [1],
                    sortable: true,
                    options: (that, { row }) => {
                        let sequence = []
                        for (let index = 1; index <= 20; index++) {
                            var seq = {
                                label: index,
                                value: index
                            }
                            sequence.push(seq)
                        }
                        return sequence
                    }
                },
                {
                    type: `number`,
                    prop: `scheduled_sequence`,
                    label: `台次`,
                    isListable: !this.$root.IsShowWithOperatingRoom || this.$root.IsShowWithOperatingRoom == `0`,
                    width: `100`,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    area: [2],
                    sortable: true
                },
                {
                    type: `numberWithSlot`,
                    prop: `scheduled_sequence`,
                    slotCol: `dic_operating_room_alias`,
                    label: `台次`,
                    isListable: this.$root.IsShowWithOperatingRoom && this.$root.IsShowWithOperatingRoom == `1`,
                    width: `200`,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    area: [1],
                    sortable: true
                },
                {
                    type: `numberWithSlot`,
                    prop: `scheduled_sequence`,
                    slotCol: `dic_operating_room_alias`,
                    label: `台次`,
                    isListable: this.$root.IsShowWithOperatingRoom && this.$root.IsShowWithOperatingRoom == `1`,
                    width: `200`,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    area: [2],
                    sortable: true
                },
                {
                    type: `custom`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    sortable: true,
                    isListable: true,
                    area: [1, 2],
                    // 自定义排序
                    sortChange: function(that, { a, b, prop, column }) {
                        let thisObj = that.$parent.$parent
                        let str1 = a[prop]
                        if (!str1) return 1
                        let str2 = b[prop]
                        if (!str2) return -1
                        let dis1Number = thisObj.DisplayOrderNumber(str1, `section`)
                        let dis2Number = thisObj.DisplayOrderNumber(str2, `section`)
                        return dis1Number - dis2Number
                    }
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `100`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `dic_opearting_ward`,
                    label: `手术区`,
                    width: `100`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `150`,
                    isListable: true,
                    sortable: true,
                    // 自定义排序
                    sortChange: function(that, { a, b, prop, column }) {
                        let thisObj = that.$parent.$parent
                        let str1 = a[prop]
                        if (!str1) return 1
                        let str2 = b[prop]
                        if (!str2) return -1
                        let dis1Number = thisObj.DisplayOrderNumber(str1, `operating_room`)
                        let dis2Number = thisObj.DisplayOrderNumber(str2, `operating_room`)
                        return dis1Number - dis2Number
                    },
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `surgical_site`,
                    label: `手术部位`,
                    width: `150`,
                    isListable: true,
                    queryable: false,
                    area: [1, 2]
                },
                {
                    type: `float`,
                    prop: `cost_time`,
                    label: `预计时长`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `datetime`,
                    prop: `apply_time`,
                    label: `申请时间`,
                    width: `120`,
                    isListable: true,
                    sortable: true,
                    area: [1, 2]
                },
                {
                    type: `datetime`,
                    prop: `push_time`,
                    label: `推送时间`,
                    width: `120`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划开始时间`,
                    width: `120`,
                    isListable: true,
                    sortable: true,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `plan_time2`,
                    label: `计划手术时间`,
                    width: `120`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    width: `200`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `anaes_methods`,
                    label: `计划麻醉方式`,
                    width: `120`,
                    isListable: true,
                    sortable: true,
                    area: !listeditWorker ? [0] : [1, 2]
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_anaes_methods`,
                    label: `计划麻醉方式`,
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20
                    },
                    area: !listeditWorker ? [1, 2] : [0],
                    options: `/api/AcisSystem/AnaesthesiaMethod/Search`
                },
                {
                    type: `custom`,
                    prop: `surgeon`,
                    label: this.T(`Schedule.plan_surgeon`),
                    width: `120`,
                    sortable: true,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    // type: `select`,
                    type: `remoteselect`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`Schedule.plan_anes_doctor`),
                    sortable: true,
                    width: `140`,
                    isListable: true,
                    colspan: 6,
                    isShowPhoto: this.isShowWorkerPhoto,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_operating_ward_id || _.includes(i.wardids, row.dic_operating_ward_id)
                                })
                            }
                            if (this.$root.UseASACheck == `1`) {
                                worksarr = worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || listeditWorker
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    area: [1, 2]
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`Schedule.plan_anes_assistants`),
                    width: `200`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || listeditWorker
                    },
                    options: (that, { row }) => {
                        // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let worksarr = _.cloneDeep(works)
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let hsworkersarr = _.cloneDeep(hsworkers)
                            hsworkersarr.forEach((item, index) => {
                                let mc = _.find(worksarr, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    worksarr.push(item)
                                }
                            })

                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_operating_ward_id || _.includes(i.wardids, row.dic_operating_ward_id)
                                })
                            }
                            if (this.$root.UseASACheck == `1`) {
                                worksarr = worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6,
                    area: [1, 2],
                    config: {
                        collapseTags: true
                    }
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: this.T(`Schedule.plan_circuit_nurse`),
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || listeditWorker
                    },
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_operating_ward_id || _.includes(i.wardids, row.dic_operating_ward_id)
                                })
                            }
                            if (this.ScheduleNurseFilterSection == `1`) {
                                let rsectionid = row.dic_section_id
                                if (rsectionid != null) {
                                    worksarr = _.filter(worksarr, function(n) {
                                        return (n.sectionids && n.sectionids.includes(rsectionid)) || n.dic_section_id == rsectionid
                                    })
                                }
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6,
                    area: [1, 2],
                    config: {
                        collapseTags: true
                        // multipleLimit:2
                    }
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`Schedule.plan_equipment_nurse`),
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || listeditWorker
                    },
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_operating_ward_id || _.includes(i.wardids, row.dic_operating_ward_id)
                                })
                            }
                            if (this.ScheduleNurseFilterSection == `1`) {
                                let rsectionid = row.dic_section_id
                                if (rsectionid != null) {
                                    worksarr = _.filter(worksarr, function(n) {
                                        return (n.sectionids && n.sectionids.includes(rsectionid)) || n.dic_section_id == rsectionid
                                    })
                                }
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6,
                    area: [1, 2],
                    config: {
                        collapseTags: true
                        // multipleLimit:2
                    }
                },
                {
                    type: `custom`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true,
                    width: `300`,
                    // colspan: 6,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `his_id`,
                    label: this.T(`his_id`),
                    width: `120`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `select`,
                    prop: `enum_surgeryscale`,
                    label: `手术等级`,
                    isListable: true,
                    width: `100`,
                    options: this.sys_enums.Enum_SurgeryScale || [],
                    area: [1, 2]
                }
                // ,
                // {
                //     type: `string`,
                //     prop: `his_remark`,
                //     label: `申请备注`,
                //     isListable: true,
                //     area: [1, 2]
                // }
            ] // 列表列
            if (this.surgeryinfopush == `true`) {
                list.push({
                    type: `custom`,
                    prop: `push_status`,
                    label: `回传状态`,
                    width: `120`,
                    area: [2],
                    isListable: true
                })
            }
            // 显示动态扩展列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)

            return list
        },
        columnList2() {
            return _.filter(this.columnList, d => {
                return d.area.indexOf(2) > -1
            }).concat([
                {
                    type: `buttongroup`,
                    prop: `oper2`,
                    width: `60`,
                    label: `操作`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain is-circle`,
                            label: ``,
                            icon: `el-icon-edit-outline`,
                            type: `primary`,
                            emit: `loadSurgeryEditView`,
                            permission: `default`,
                            tooltip: `编辑`
                        }
                    ]
                }
            ])
        },
        columnList3() {
            return _.filter(this.columnList, d => {
                return d.area.indexOf(1) > -1
            }).concat([
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    width: `125`,
                    label: `操作`,
                    isListable: true,
                    readonly: false,
                    fixed: `right`,
                    options: (that, { row }) => {
                        if (row.enum_surgery_status == 20) {
                            return [
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-edit-outline`,
                                    type: `primary`,
                                    emit: `loadSurgeryEditView`,
                                    permission: `default`,
                                    tooltip: `编辑`
                                },
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-close`,
                                    type: `danger`,
                                    emit: `cancelSchedule`,
                                    permission: `surgery_list:cancelSchedule`,
                                    tooltip: `取消排程`
                                },
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-printer`,
                                    type: `primary`,
                                    emit: `printOne`,
                                    permission: `default`,
                                    tooltip: `打印`
                                }
                            ]
                        } else {
                            return [
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-edit-outline`,
                                    type: `primary`,
                                    emit: `loadSurgeryEditView`,
                                    permission: `default`,
                                    tooltip: `编辑`
                                },
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-printer`,
                                    type: `primary`,
                                    emit: `printOne`,
                                    permission: `default`,
                                    tooltip: `打印`
                                }
                            ]
                        }
                    }
                }
            ])
        },

        roomSettingsColumns() {
            // 没有应用麻醉人员权限
            let editWorker = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) === -1
            // 没有应用护士人员权限
            let noHaveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) === -1
            // 排程助手按钮权限
            let intelligencePermission = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:intelligence`) > -1
            let me = this
            let otherDoctorIds = me.roomSettings.data.schedule_doctor_ids
            let otherNurseIds = me.roomSettings.data.schedule_nurse_ids
            console.log(`roomSettings`, me.roomSettings.data)
            let cols = [
                {
                    type: `textarea`,
                    prop: `schedule_doctor`,
                    label: `已排医生`,
                    colspan: 24,
                    showCol: true,
                    config: {
                        minRows: 2
                    },
                    readonly: true
                },
                {
                    type: `textarea`,
                    prop: `schedule_nurse`,
                    label: `已排护士`,
                    colspan: 24,
                    showCol: true,
                    config: {
                        minRows: 2
                    },
                    readonly: true
                },
                {
                    type: `select`,
                    prop: `anesthetist_id`,
                    label: this.T(`Schedule.plan_anes_doctor`),
                    colspan: 12,
                    showCol: true,
                    options: (that, { row }) => {
                        let workers = this.isWorkerByDuty == `0` ? this.worker[`医生`] : this.worker[`麻醉医生`]
                        let deepworkers = JSON.parse(JSON.stringify(workers))
                        // 手术间设置
                        if (me.scheduleWorkerFilter == `2`) {
                            deepworkers = _.filter(deepworkers, function(i) {
                                return !me.roomSettings.data.dic_operating_ward_id || _.includes(i.wardids, me.roomSettings.data.dic_operating_ward_id)
                            })
                        }
                        if (me.roomSettingWorkerConfig) {
                            let otherWorkerId = otherDoctorIds
                            deepworkers = otherWorkerId && _.filter(deepworkers, d => {
                                return !_.includes(otherWorkerId, d.value)
                            })
                        }
                        console.log(`麻醉医生Id:` + row.anesthetist_id, deepworkers)
                        return deepworkers
                    },
                    readonly: editWorker
                },
                {
                    type: `multiselect`,
                    prop: `anesthetist_assistant_id`,
                    label: this.T(`Schedule.plan_anes_assistants`),
                    showCount: 3,
                    collapseTags: false,
                    colspan: 12,
                    showCol: true,
                    readonly: editWorker,
                    options: (that, { row }) => {
                        // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        let workers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                        let deepworkers = JSON.parse(JSON.stringify(workers))
                        let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                        hsworkers.forEach((item, index) => {
                            let mc = _.find(deepworkers, x => x.value == item.value)
                            if (mc) {
                            } else {
                                deepworkers.push(item)
                            }
                        })
                        // 手术间设置
                        if (me.scheduleWorkerFilter == `2`) {
                            deepworkers = _.filter(deepworkers, function(i) {
                                return !me.roomSettings.data.dic_operating_ward_id || _.includes(i.wardids, me.roomSettings.data.dic_operating_ward_id)
                            })
                        }
                        if (me.roomSettingWorkerConfig) {
                            let otherWorkerId1 = otherDoctorIds
                            let otherWorkerId2 = otherNurseIds
                            let otherWorkerId = [...otherWorkerId1, ...otherWorkerId2]
                            deepworkers = otherWorkerId && _.filter(deepworkers, d => {
                                return !_.includes(otherWorkerId, d.value)
                            })
                        }

                        return deepworkers
                    },
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `multiselect`,
                    prop: `circuit_nurse_id`,
                    label: this.T(`Schedule.plan_circuit_nurse`),
                    showCount: 3,
                    collapseTags: false,
                    options: (that, { row }) => {
                        let workers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                        let deepworkers = JSON.parse(JSON.stringify(workers))
                        // 手术间设置
                        if (me.scheduleWorkerFilter == `2`) {
                            deepworkers = _.filter(deepworkers, function(i) {
                                return !me.roomSettings.data.dic_operating_ward_id || _.includes(i.wardids, me.roomSettings.data.dic_operating_ward_id)
                            })
                        }
                        if (me.roomSettingWorkerConfig) {
                            let otherWorkerId = otherNurseIds
                            deepworkers = otherWorkerId && _.filter(deepworkers, d => {
                                return !_.includes(otherWorkerId, d.value)
                            })
                        }

                        return deepworkers
                    },
                    colspan: 12,
                    showCol: true,
                    readonly: noHaveNursePermission,
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `multiselect`,
                    prop: `equipment_nurse_id`,
                    label: this.T(`Schedule.plan_equipment_nurse`),
                    showCount: 3,
                    collapseTags: false,
                    options: (that, { row }) => {
                        let workers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                        let deepworkers = JSON.parse(JSON.stringify(workers))
                        // 手术间设置
                        if (me.scheduleWorkerFilter == `2`) {
                            deepworkers = _.filter(deepworkers, function(i) {
                                return !me.roomSettings.data.dic_operating_ward_id || _.includes(i.wardids, me.roomSettings.data.dic_operating_ward_id)
                            })
                        }
                        if (me.roomSettingWorkerConfig) {
                            let otherWorkerId = otherNurseIds
                            deepworkers = otherWorkerId && _.filter(deepworkers, d => {
                                return !_.includes(otherWorkerId, d.value)
                            })
                        }

                        return deepworkers
                    },
                    colspan: 12,
                    showCol: true,
                    readonly: noHaveNursePermission,
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `分配科室`,
                    options: this.section,
                    colspan: 12,
                    showCol: intelligencePermission
                },
                {
                    type: `select`,
                    prop: `surgeon_id`,
                    label: `分配术者`,
                    options: (that, { row }) => {
                        let workers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                        let deepworkers = JSON.parse(JSON.stringify(workers))
                        // 手术间设置
                        if (me.scheduleWorkerFilter == `2`) {
                            deepworkers = _.filter(deepworkers, function(i) {
                                return !me.roomSettings.data.dic_operating_ward_id || _.includes(i.wardids, me.roomSettings.data.dic_operating_ward_id)
                            })
                        }
                        if (me.roomSettingWorkerConfig) {
                            let otherWorkerId = otherDoctorIds
                            deepworkers = otherWorkerId && _.filter(deepworkers, d => {
                                return !_.includes(otherWorkerId, d.value)
                            })
                        }

                        return deepworkers
                    },
                    colspan: 12,
                    showCol: intelligencePermission
                },
                {
                    type: `string`,
                    prop: `dic_surgery_name`,
                    label: `分配术式`,
                    colspan: 12,
                    showCol: intelligencePermission
                }
            ]
            return _.filter(cols, col => {
                return col.showCol == true
            })
        },
        autoScheduleTitle() {
            return `排程助手(${this.autoScheduleSurgeries.length}/${this.unScheduledLength})`
        },
        customScheduleFixedColumns() {
            // 获取排程界面自定义固定列参数,:手术间,台次,操作
            if (this.$root.CustomScheduleFixedColumns && this.$root.CustomScheduleFixedColumns.trim()) {
                return this.$root.CustomScheduleFixedColumns.trim().split(`,`)
            }
            return []
        },
        titleLabel() {
            return function(row) {
                let title = `患者:${row.patient_name} 性别:${row.sex || `--`} 年龄:${row.age || `--`} 
病例号:${row.visit_no || `--`} 
术前诊断:${row.diseases || `--`}
拟施手术:${row.surgeries || `--`}
${this.T(`Schedule.plan_surgeon`)}:${row.surgeon || `--`}
手术科室:${row.dic_section || `--`}
${this.T(`Schedule.plan_anes_doctor`)}:${row.plan_anes_doctor == null ? `` : row.plan_anes_doctor.label}
申请台次:${row.sequence || ``}
申请时间:${this.$moment(row.apply_time).format(`YYYY-MM-DD HH:mm:ss`)}
备注:${row.his_remark || ``}
传染病:${row.infectious || ``}
麻醉类型:${row.is_local_anes_val || ``}
`
                return title
            }
        },
        styleObject() {
            return function(active, setting) {
                let style = {
                    color: active ? this.roomStyle.activecolor : this.roomStyle.color,
                    fontSize: active ? this.roomStyle.activefontSize : this.roomStyle.fontSize
                }
                if (this.roomStyle.isEnable === `1`) {
                    // 读取参数配置中的颜色，没有配置数据时默认白色
                    let backgroundColor = this.roomStyle.backgroundColor == `` ? `white` : this.roomStyle.backgroundColor
                    let activebackgroundColor = this.roomStyle.activebackgroundColor == `` ? `white` : this.roomStyle.activebackgroundColor
                    let bgColor = this.roomStyle.bgColor == `` ? `white` : this.roomStyle.bgColor
                    let activebgColor = this.roomStyle.activebgColor == `` ? `white` : this.roomStyle.activebgColor
                    // 配置了麻醉医生，没有配置巡回护士或器械护士
                    if (setting.anesthetist_id && !setting.circuit_nurse_id && !setting.equipment_nurse_id) {
                        style.background = active ? `linear-gradIEnt(${activebgColor} 50%,${activebackgroundColor} 50%)` : `linear-gradIEnt(${bgColor} 50%,${backgroundColor} 50%)`
                    } else if (!setting.anesthetist_id && (setting.circuit_nurse_id || setting.equipment_nurse_id)) {
                        // 配置了巡回护士或器械护士，没有配置麻醉医生
                        style.background = active ? `linear-gradIEnt(${activebackgroundColor} 50%,${activebgColor} 50%)` : `linear-gradIEnt(${backgroundColor} 50%,${bgColor} 50%)`
                    } else if (setting.anesthetist_id && (setting.circuit_nurse_id || setting.equipment_nurse_id)) {
                        // 配置了麻醉医生和巡回护士/器械护士
                        style.background = active ? `linear-gradIEnt(${activebgColor} 50%,${activebgColor} 50%)` : `linear-gradIEnt(${bgColor} 50%,${bgColor} 50%)`
                    } else {
                        style.backgroundColor = active ? this.roomStyle.activebackgroundColor : this.roomStyle.backgroundColor
                    }
                } else {
                    style.backgroundColor = active ? this.roomStyle.activebackgroundColor : this.roomStyle.backgroundColor
                }
                return style
            }
        },
        getsectionauth() {
            return this.dic_section_arr
        }
    },
    destroyed() {
        window.clearInterval(this.timer_interval)
    },
    beforeDestroy() {
        // 暂存查询条件
        var schedulingCondition = {
            scheduling_date: this.scheduling_date,
            dataArea: this.dataArea,
            isLoadToSchedule: this.isLoadToSchedule,
            isLoadScheduled: this.isLoadScheduled,
            isLoadCancelScheduled: this.isLoadCancelScheduled,
            dic_operating_ward_id: this.dic_operating_ward_id,
            dic_operating_ward_id_arr: this.dic_operating_ward_id_arr,
            selectsurgeryType: this.selectsurgeryType,
            active_room_id: this.active_room_id,
            searchValue: this.$refs[`surgery-list`] && this.$refs[`surgery-list`].searchValue
        }
        sessionStorage.setItem(`consd`, JSON.stringify(schedulingCondition))
    },
    methods: {

        checkSurgery(ids) {
            // 存储校验
            return new Promise((resolve, reject) => {
                let that = this // , int[] surgeryIds
                let req = that.myaxios.put(`/api/Preoperative/Schedule/CheckSurgery`, ids)
                req.then(d => {
                    resolve(d)
                }).catch(e => {
                    reject(e)
                })
            })
        },
        putScheduled(data) {
            let that = this
            let roomIds = [this.active_room_id]
            let reqs = data.map(d => {
                let info = _.filter(this.activeRoomScheduled_list, { id: d.id })[0]
                d.scheduled_sequence = d.scheduled_sequence
                d.plan_anes_doctor = d.plan_anes_doctor == `` || d.plan_anes_doctor < 0 ? -1 : d.plan_anes_doctor && d.plan_anes_doctor.value
                d.plan_anes_assistants = d.plan_anes_assistants && d.plan_anes_assistants.map(a => a && a.value)
                d.plan_circuit_nurse = d.plan_circuit_nurse && d.plan_circuit_nurse.map(a => a && a.value)
                d.plan_equipment_nurse = d.plan_equipment_nurse && d.plan_equipment_nurse.map(a => a && a.value)
                d.plan_anaes_methods = d.plan_anaes_methods && d.plan_anaes_methods.map(a => a && a.value)
                if (info != null) {
                    d.visit_info = {
                        id: info.visit_id,
                        enum_visit_type: info.enum_visit_type,
                        visit_no: info.visit_no,
                        outpatient_no: info.outpatient_no,
                        name: info.patient_name
                    }
                }
                return this.myaxios.put(`/api/Preoperative/Schedule/UpdateSchedule`, d)
            })
            return new Promise((resolve, reject) => {
                let req = this.myaxios.all(...reqs)
                req.then(res => {
                    // isAutoScheduledSequence参数为1则自动重置台次
                    if (that.isAutoScheduledSequence == `1`) {
                        this.ReScheduleSurgeries(roomIds).then(ds => {
                            this.ReloadListData()
                            that.$message.success(`保存成功`)
                            resolve(res)
                        })
                    } else {
                        this.ReloadListData()
                        that.$message.success(`保存成功`)
                        resolve(res)
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        },
        // 拖进手术间
        dragInRoom(e, id) {
            e.stopPropagation()
            e.preventDefault()
            if (this.active_room_id == 0) {
                let that = this
                this.dragEventTager = e.target
                that.scrolling_in_id = id
            }
        },
        // 拖动区域移除手术间div时
        dragOutRoom(e) {
            e.stopPropagation()
            e.preventDefault()
            if (this.active_room_id == 0) {
                let that = this
                if (this.dragEventTager === e.target) {
                    that.scrolling_in_id = 0
                    this.dragEventTager = null
                }
            }
        },
        /// 开始滚动
        startScroll(e, direction) {
            e.preventDefault()
            let that = this
            this.setIntervalScroll = window.setInterval(
                direction => {
                    this.$nextTick(() => {
                        if (that.$refs.scrollpaneRef) {
                            let $scrollWrapper = that.$refs.scrollpaneRef.scrollWrapper
                            $scrollWrapper.scrollLeft = direction == `left` ? $scrollWrapper.scrollLeft - 2 : $scrollWrapper.scrollLeft + 2
                        }
                    })
                },
                5,
                direction
            )
        },
        dragover(e) {
            e.preventDefault()
        },
        endScroll(e) {
            let that = this
            e.preventDefault()
            window.clearInterval(that.setIntervalScroll)
        },
        ishavehelpSection(permiskey) {
            if (permiskey != `all`) {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:${permiskey}`) != -1
            } else {
                return (
                    this.permissions &&
                    this.permissions.findIndex(
                        item =>
                            item.permission === `scheduling:helpSection` ||
                            item.permission === `scheduling:helpWorker` ||
                            item.permission === `scheduling:helpSurgery` ||
                            item.permission === `scheduling:helpChangeRoom` ||
                            item.permission === `scheduling:helpSetAnesDoctor` ||
                            item.permission === `scheduling:helpOneKeySchedule` ||
                            item.permission === `scheduling:clearWorkersSettings`
                    ) != -1
                )
            }
        },
        isHaveCancelSchedule(permiskey) {
            if (permiskey != `all`) {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:${permiskey}`) != -1
            } else {
                return (
                    this.permissions &&
                    this.permissions.findIndex(
                        item => item.permission === `scheduling:cancelSchedule` || item.permission === `scheduling:rejectApprove` || item.permission === `scheduling:rejectApply`
                    ) != -1
                )
            }
        },
        cancel(command) {
            let that = this
            if (command == `cancelSchedule`) {
                that.cancelScheduleAll()
            }
            if (command == `cancelSurgery`) {
                that.loadingOverruleView(command)
            }
            if (command == `rejectApprove`) {
                that.loadingOverruleView(command)
            }
            if (command == `rejectApply`) {
                that.loadingOverruleView(command)
            }
        },
        loadingOverruleView(btnName) {
            let that = this
            this.surgeryIds = []
            let rejectApplyMsgs = ``
            if (that.checkedRows && that.checkedRows.length > 0) {
                if (btnName == `rejectApply`) {
                    // 驳回申请
                    that.checkedRows.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            this.surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                } else if (btnName == `rejectApprove`) {
                    // 驳回审批
                    that.checkedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            this.surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                } else {
                    // 取消手术
                    that.checkedRows.map(d => {
                        if (d.enum_surgery_status == 20) {
                            this.surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                }
            }
            let msg = btnName == `cancelSurgery` ? `取消` : `驳回`
            if (this.surgeryIds.length == 0) {
                if (btnName == `rejectApply`) {
                    this.$message.warning(`请选择待排程或已排程的手术!`)
                }
                if (btnName == `rejectApprove`) {
                    this.$message.warning(`请选择待排程的手术!`)
                }
                if (btnName == `cancelSurgery`) {
                    this.$message.warning(`请选择已排程的手术!`)
                }
                return
            }
            // 增加驳回前提示
            rejectApplyMsgs = rejectApplyMsgs.slice(0, rejectApplyMsgs.length - 1)
            if (btnName == `rejectApply`) {
                rejectApplyMsgs += `的手术申请`
            } else if (btnName == `rejectApprove`) {
                rejectApplyMsgs += `的手术审核`
            } else {
                rejectApplyMsgs += `的已排程手术`
            }
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `此操作将${msg}${rejectApplyMsgs}`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
                    if (col) {
                        if (this.rejectReasons && this.rejectReasons.length > 0) {
                            col.options = this.rejectReasons
                            col.type = `select`
                        } else {
                            col.options = []
                            col.type = `string`
                        }
                    }
                    if (btnName == `cancelSurgery`) {
                        this.overrule.title = `取消手术`
                        col.label = `取消原因`
                    }
                    this.overrule.emitBtnName = btnName
                    this.overrule.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadRejectResons() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ApplyRejectResons`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.rejectReasons = data.value
                            .trim()
                            .split(`,`)
                            .map(x => {
                                return {
                                    label: x,
                                    value: x
                                }
                            })
                    } else {
                        this.rejectReasons = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadPrintSurgeryConfig() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=PrintSurgeryConfig`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.printSurgeryConfigs = JSON.parse(data.value)
                    } else {
                        this.printSurgeryConfigs = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        cancelScheduleAll() {
            let that = this

            let pmise = new Promise((resolve, reject) => {
                let chckrows = _.filter(this.checkedRows, { enum_surgery_status: 20 })
                if (chckrows.length == 0) {
                    this.$message.warning(`请选择已排程手术!`)
                    return
                }
                if (chckrows.length > 0) {
                    let msgs = ``
                    chckrows.map(d => {
                        msgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                    })
                    msgs = msgs.slice(0, msgs.length - 1)
                    return this.$confirm(`请确认是否取消${msgs}的排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve(chckrows)
                        })
                        .catch(e => {
                            reject([])
                        })
                } else {
                    that.$message.success(`请选择已排程手术!`)
                }
            })

            pmise
                .then(crs => {
                    let roomIds = []
                    let reqs =
                        crs &&
                        crs.map(d => {
                            roomIds.push(d.dic_operating_room_id)
                            return this.myaxios.put(`/api/Preoperative/Schedule/CancelSchedule/${d.id}`)
                        })
                    this.myaxios
                        .all(...reqs)
                        .then(data => {
                            this.ReScheduleSurgeries(roomIds).then(ds => {
                                this.ReloadRoom()
                                this.ReloadListData()
                                this.loadUnScheduledAndScheduled()
                                this.$message.success(`取消排程成功`)
                            })
                        })
                        .catch(e => {})
                })
                .catch(e => {})
        },
        saveOverrule(row) {
            let that = this
            let msg = that.overrule.emitBtnName == `cancelSurgery` ? `取消` : `驳回`
            if (that.surgeryIds.length == 0) {
                if (that.overrule.emitBtnName == `rejectApply`) {
                    this.$message.warning(`请选择待排程或已排程的手术!`)
                }
                if (that.overrule.emitBtnName == `rejectApprove`) {
                    this.$message.warning(`请选择待排程的手术!`)
                }
                if (that.overrule.emitBtnName == `cancelSurgery`) {
                    this.$message.warning(`请选择已排程的手术!`)
                }
                return
            }

            try {
                that.surgeryIds.map(d => {
                    let requestData = {
                        id: d,
                        visit_info: null,
                        reject_reason: row.reject_reason
                    }
                    if (that.overrule.emitBtnName == `rejectApply`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/Reject`, requestData)
                        req.then(data => {
                            let rooIds = [that.active_room_id]
                            that.ReScheduleSurgeries(rooIds).then(ds => {
                                that.ReloadRoom()
                                that.ReloadListData()
                            })

                            // 调用手术回写
                            let pushModel = {
                                surgeryId: d,
                                surgeryInfoSendType: 1
                            }
                            var reps = this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, pushModel)
                            reps.then(data => {})
                        })
                    }
                    if (that.overrule.emitBtnName == `rejectApprove`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/RejectApprove`, requestData)
                        req.then(data => {
                            this.ReloadRoom()
                            this.ReloadListData()
                        })
                    }
                    if (that.overrule.emitBtnName == `cancelSurgery`) {
                        let req = this.myaxios.put(`/api/Preoperative/Schedule/CancelSurgery?surgeryId=${requestData.id}&&reason=${requestData.reject_reason}`)
                        req.then(data => {
                            let rooIds = [that.active_room_id]
                            that.ReScheduleSurgeries(rooIds).then(ds => {
                                that.ReloadRoom()
                                that.ReloadListData()
                            })
                        })
                    }
                })
                that.$message.success(`手术${msg}成功`)
                that.surgeryIds = []
                that.overrule.dialogFormVisible = false
            } catch (e) {
                that.$message.error(`手术${msg}失败`)
            }
        },
        timer() {
            let that = this
            that.timer_interval = window.setInterval(() => {
                that.ReloadListData()
                that.loadNewSurgeryList()
            }, this.getSurgeryInfoSyncTime)
        },
        destroyed() {
            window.clearInterval(this.timer_interval)
        },
        isChecked(row) {
            let that = this
            let num = ``
            let idx = _.findIndex(that.checkedRows, c => {
                return c.id == row.id
            })
            if (idx !== -1) {
                num = idx + 1
            }
            return num
        },
        showPhoto(row) {
            if (row.surgeon_id && row.surgeon_photo) {
                row.worker_photo = `${this.$root.BASE_URL}api/AcisSystem/Worker/GetPictureFile/${row.surgeon_id}?fileName=${row.surgeon_photo}`
            } else {
                row.worker_photo = this.workerIcon
            }
        },
        afterSave(surgeryId, surgeryStatus, operatingRoomId) {
            let that = this
            let surgeryIds = []
            if (surgeryStatus == 10) {
                surgeryIds.push(surgeryId)
                that.checkSurgery(surgeryIds).then((d) => {
                    if (d && d != ``) {
                        this.$confirm(d, `提示`, {
                            confirmButtonText: `确定排程`,
                            cancelButtonText: `取消排程`,
                            type: `warning`,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                that.doScheduleSurgeries(that.scheduling_date, operatingRoomId, surgeryIds, 1)
                            })
                            .catch(e => {
                                let rooIds = [that.active_room_id]
                                this.ReScheduleSurgeries(rooIds).then(ds => {
                                    that.refreshList()
                                })
                            })
                    } else {
                        that.doScheduleSurgeries(that.scheduling_date, operatingRoomId, surgeryIds, 1)
                    }
                })
            } else {
                that.refreshList()
            }
        },
        doScheduleSurgeries(schedulingDate, operatingRoomId, surgeryIds, type) {
            let that = this
            let req = that.myaxios.put(`/api/Preoperative/Schedule/ScheduleSurgeries?date=${schedulingDate}&roomId=${operatingRoomId}`, surgeryIds)
            req.then(data => {
                let rooIds = [that.active_room_id]
                this.ReScheduleSurgeries(rooIds).then(ds => {
                    if (type == 1) {
                        that.refreshList()
                    } else if (type == 2) {
                        that.ReloadRoom()
                        that.ReloadListData()
                        that.scrolling_in_id = 0 // 把当前拖拽手术间置空
                    } else if (type == 3) {
                        that.ReloadRoom()
                        that.ReloadListData()
                        that.changeRoom.dialogFormVisible = false
                    }
                    that.$message.success(`排程成功`)
                })
            }).catch(e => {
                that.$message.error(`排程失败`)
            })
        },
        refreshList() {
            this.ReloadRoom()
            this.ReloadListData()
        },
        pushSchedule() {
            let pushRows = []
            if (this.checkedRows.length > 0) {
                pushRows = this.checkedRows
            } else {
                // 若未勾选则回传全部
                pushRows = this.unschedule_list.concat(this.scheduled_list)
            }
            if (pushRows.length > 0) {
                let reqs = pushRows.map(d => {
                    // if (d.push_status != 1) {
                    let postdata = {
                        surgeryId: d.id,
                        surgeryInfoSendType: 2
                    }
                    return this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, postdata)
                    // }
                })
                this.myaxios.all(...reqs).then(() => {
                    // this.ReloadRoom()
                    this.ReloadListData()
                    this.$message.success(`排程回传完成`)
                })
            } else {
                this.$message.warning(`请先选择要回传的记录！`)
            }
        },
        cancelSchedule({ index, row }) {
            let pmise = new Promise((resolve, reject) => {
                let chckrows = _.filter(this.checkedRows, { enum_surgery_status: 20 })
                if (chckrows.length > 0) {
                    return this.$confirm(`检测到选择了多条数据，是否全部取消排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve(chckrows)
                        })
                        .catch(e => {
                            reject([])
                        })
                } else {
                    return this.$confirm(`是否取消排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve([row])
                        })
                        .catch(e => {
                            reject([])
                        })
                }
            })

            pmise
                .then(crs => {
                    let roomIds = []
                    let reqs =
                        crs &&
                        crs.map(d => {
                            roomIds.push(d.dic_operating_room_id)
                            return this.myaxios.put(`/api/Preoperative/Schedule/CancelSchedule/${d.id}`)
                        })
                    this.myaxios
                        .all(...reqs)
                        .then(data => {
                            this.ReScheduleSurgeries(roomIds).then(ds => {
                                this.ReloadRoom()
                                this.ReloadListData()
                                this.loadUnScheduledAndScheduled()
                                this.$message.success(`取消排程成功`)
                            })
                        })
                        .catch(e => {})
                })
                .catch(e => {})
        },
        rowContextMenu({ row, event }) {
            event && event.preventDefault()
            let that = this
            let surgeryIds = []
            that.checkedRows.map(d => {
                if (d.enum_surgery_status == 10) {
                    surgeryIds.push(d.id)
                }
            })
            if (surgeryIds.length == 0) {
                this.$message.warning(`请选择待排程手术进行排程`)
                return
            }
            that.changeRoom.title = `手术排程`
            that.changeRoom.type = `schedule`
            that.loadChangeRoomForm(surgeryIds)
        },
        ScheduleSurgeries(evt, room) {
            let that = this
            let removeids =
                that[`listview/remove_item`] &&
                _.filter(that[`listview/remove_item`], op => {
                    return op.enum_surgery_status < 30
                }).map(d => d.id)

            that.checkSurgery(removeids).then((d) => {
                if (d && d != ``) {
                    this.$confirm(d, `提示`, {
                        confirmButtonText: `确定排程`,
                        cancelButtonText: `取消排程`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            that.doScheduleSurgeries(that.scheduling_date, room.id, removeids, 2)
                        })
                        .catch(e => {
                            let rooIds = [that.active_room_id]
                            this.ReScheduleSurgeries(rooIds).then(ds => {
                                that.refreshList()
                            })
                        })
                } else {
                    that.doScheduleSurgeries(that.scheduling_date, room.id, removeids, 2)
                }
            })
        },
        openaddfrom() {
            let that = this
            that.addfrom.dialogFormVisible = true
            that.addfrom.defaultplanTime = that.$moment(this.scheduling_date).format(`YYYY/MM/DD 08:00:00`)
            return false
        },
        afteradd(aftersaveid) {
            let that = this

            that.$message.success(`保存成功`)
            that.refreshList()
        },
        ReScheduleSurgeries(roomIds) {
            let that = this
            return new Promise(resolve => {
                let req = that.myaxios.put(`/api/Preoperative/Schedule/ReScheduleSurgeries?date=${that.scheduling_date}`, roomIds)
                req.then(data => {
                    resolve([])
                }).catch(e => {
                    that.$message.error(`取消后重新调整台次失败!`)
                })
            })
        },
        loadUnScheduledAndScheduled() {
            let that = this
            return new Promise(resolve => {
                // 获取待排程
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetUnScheduled`, { date: that.dataArea ? `` : that.scheduling_date })
                // 获取已排程
                let req1 = this.myaxios.get(`/api/Preoperative/Schedule/GetNewScheduled`, { date: that.dataArea ? `` : that.scheduling_date })
                // 获取手术提醒
                let req2 = this.myaxios.get(`/api/Preoperative/Schedule/GetSurgeryAlertInfo`, { date: that.dataArea ? `` : that.scheduling_date })
                this.myaxios.all(req, req1, req2).then(([data, data1, alertInfo]) => {
                    // added by xiaorui,ACIS-23994 ,手术排程 数据列表 安排术间增加了3个权限控制
                    if (!this.IsHavePermission(`scheduling_list_moveEmergency`)) {
                        data = _.filter(data, function(i) {
                            return i.enum_surgery_type !== 1 && i.enum_surgery_type !== null
                        })
                    }
                    if (!this.IsHavePermission(`scheduling_list_moveElective`)) {
                        data = _.filter(data, function(i) {
                            return i.enum_surgery_type !== 2
                        })
                    }
                    if (!this.IsHavePermission(`scheduling_list_moveDeadline`)) {
                        data = _.filter(data, function(i) {
                            return i.enum_surgery_type !== 3
                        })
                    }

                    let filter = this.IsHavePermission(`scheduling:CrossRegionScheduling`) ? {} : { dic_operating_ward_id: this.dic_operating_ward_id }
                    let r = _.filter(data, filter).map(d => {
                        if (d.sequence && this.IsNum(d.sequence)) {
                            d.sequence_s = d.sequence && parseInt(d.sequence)
                        } else {
                            d.sequence_s = d.sequence
                        }
                        if (d.sequence && this.IsNum(d.sequence)) {
                            d.sequence_apply = d.sequence && parseInt(d.sequence)
                        }
                        if (that.surgeryNameConfig && _.includes(that.surgeryNameConfig, `Surgery_Region`) && d.surgery_region) {
                            var surgeriesT = ``
                            d.surgery_region.forEach(sritem => {
                                surgeriesT += sritem.surgery_name + (sritem.surgery_region && that.surgeryNameConfig.replace(`Surgery_Region`, sritem.surgery_region)) + `,`
                            })
                            d.surgeries = surgeriesT.slice(0, -1)
                        }
                        if (this.IsHavePermission(`scheduling_list_toScheduling`)) {
                            d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                        } else {
                            d.class_name = `ignore-drag`
                        }
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                        d.worker_photo = `` // 手术医生照片
                        // 行样式 scheduleSurgeryRowStyleObj
                        if (that.scheduleSurgeryRowStyleObj) {
                            let rowStyle = {}
                            if (d.enum_surgery_type == 1 && that.scheduleSurgeryRowStyleObj.surgerytypeJZ) {
                                rowStyle[`background-color`] = `${that.scheduleSurgeryRowStyleObj.surgerytypeJZ} !important`
                            } else if (d.enum_surgery_type == 2 && that.scheduleSurgeryRowStyleObj.surgerytypeZQ) {
                                rowStyle[`background-color`] = `${that.scheduleSurgeryRowStyleObj.surgerytypeZQ} !important`
                            }
                            if (d.infectious && that.scheduleSurgeryRowStyleObj.infectiousInfo && (that.scheduleSurgeryRowStyleObj.infectiousInfo.filter(value => d.infectious.split(`,`).includes(value)).length > 0 || _.includes(that.scheduleSurgeryRowStyleObj.infectiousInfo, d.infectious))) { // 已确认
                                rowStyle.color = `${that.scheduleSurgeryRowStyleObj.infectious} !important`
                            }
                            if (that.scheduleSurgeryRowStyleObj.AgeTipConfig && that.scheduleSurgeryRowStyleObj.AgeTipConfig.length > 0) { // 年龄
                                var TipInfo = that.scheduleSurgeryRowStyleObj.AgeTipConfig.filter(i => {
                                    return i.Min <= d.age_int && i.Max >= d.age_int
                                })
                                if (TipInfo && TipInfo.length > 0) {
                                    rowStyle.color = `${TipInfo[0].FontColor} !important`
                                }
                            }
                            d.row_style = rowStyle
                        }

                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                        return d
                    })
                    // 区分待排程和取消排程手术
                    if (that.showCancelScheduledList) {
                        let r2 = _.filter(r, function(i) {
                            return i.is_cancel_scheduled
                        })
                        that.cancelScheduledLength = r2.length
                        that.cancelSchedule_list = that.isLoadCancelScheduled ? r2 : []
                        r = _.filter(r, function(i) {
                            return !i.is_cancel_scheduled
                        })
                    }
                    that.unScheduledLength = r.length
                    let r1 = _.filter(data1, filter).map(d => {
                        if (d.scheduled_sequence && this.IsNum(d.scheduled_sequence)) {
                            d.sequence_s = d.scheduled_sequence && parseInt(d.scheduled_sequence)
                            d.scheduled_sequence_num = d.scheduled_sequence && parseInt(d.scheduled_sequence)
                        } else {
                            d.sequence_s = d.scheduled_sequence
                        }
                        if (d.sequence && this.IsNum(d.sequence)) {
                            d.sequence_apply = d.sequence && parseInt(d.sequence)
                        }
                        if (that.surgeryNameConfig && _.includes(that.surgeryNameConfig, `Surgery_Region`) && d.surgery_region) {
                            var surgeriesT = ``
                            d.surgery_region.forEach(sritem => {
                                surgeriesT += sritem.surgery_name + (sritem.surgery_region && that.surgeryNameConfig.replace(`Surgery_Region`, sritem.surgery_region)) + `,`
                            })
                            d.surgeries = surgeriesT.slice(0, -1)
                        }
                        if (this.IsHavePermission(`scheduling_list_toScheduling`)) {
                            d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                        } else {
                            d.class_name = `ignore-drag`
                        }
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                        d.worker_photo = `` // 手术医生照片
                        // 行样式 scheduleSurgeryRowStyleObj
                        if (that.scheduleSurgeryRowStyleObj) {
                            let rowStyle = {}
                            if (d.enum_surgery_type == 1 && that.scheduleSurgeryRowStyleObj.surgerytypeJZ) {
                                rowStyle[`background-color`] = `${that.scheduleSurgeryRowStyleObj.surgerytypeJZ} !important`
                            } else if (d.enum_surgery_type == 2 && that.scheduleSurgeryRowStyleObj.surgerytypeZQ) {
                                rowStyle[`background-color`] = `${that.scheduleSurgeryRowStyleObj.surgerytypeZQ} !important`
                            }
                            if (d.infectious && that.scheduleSurgeryRowStyleObj.infectiousInfo && _.includes(that.scheduleSurgeryRowStyleObj.infectiousInfo, d.infectious)) { // 已确认
                                rowStyle.color = `${that.scheduleSurgeryRowStyleObj.infectious} !important`
                            }
                            if (that.scheduleSurgeryRowStyleObj.AgeTipConfig && that.scheduleSurgeryRowStyleObj.AgeTipConfig.length > 0) { // 年龄
                                var TipInfo = that.scheduleSurgeryRowStyleObj.AgeTipConfig.filter(i => {
                                    return i.Min <= d.age_int && i.Max >= d.age_int
                                })
                                if (TipInfo && TipInfo.length > 0) {
                                    rowStyle.color = `${TipInfo[0].FontColor} !important`
                                }
                            }
                            d.row_style = rowStyle
                        }

                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)

                        return d
                    })
                    that.ScheduledLength = r1.length || 0
                    that.ScheduledLength0 = _.filter(r1, { enum_surgery_status: 20 }).length || 0
                    that.ScheduledLength1 = that.ScheduledLength - that.ScheduledLength0
                    that.unschedule_list = that.isLoadToSchedule ? r : []
                    that.scheduled_list = that.isLoadScheduled ? r1 : []
                    let orderByFileds = []
                    if (that.scheduleCustomOrder && that.scheduleCustomOrder != `` && that.scheduleCustomOrder != ` `) {
                        orderByFileds = that.scheduleCustomOrder.split(`,`).map(d => {
                            let sOne =
                                _.find(that.orderItems, order => {
                                    return order.orderName == d
                                }) || ``
                            return sOne.orderField
                        })
                    }

                    let allschedules = that.unschedule_list.concat(that.scheduled_list)
                    if (that.showCancelScheduledList) {
                        allschedules = allschedules.concat(that.cancelSchedule_list)
                    }
                    if (orderByFileds.length > 0) {
                        allschedules = _.orderBy(allschedules, orderByFileds, [`asc`])
                    }
                    // 根据选择的手术类型做过滤，择期，急诊，日间
                    if (allschedules.length > 0 && that.selectsurgeryType > 0) {
                        if (that.selectsurgeryType == 1 || that.selectsurgeryType == 2) {
                            allschedules = _.filter(allschedules, function(i) {
                                return i.enum_surgery_type == that.selectsurgeryType
                            })
                        }

                        if (that.selectsurgeryType == 3) {
                            allschedules = _.filter(allschedules, function(i) {
                                return i.is_day_surgery == true
                            })
                        }
                    }

                    var sectionList = _.filter(allschedules, function(i) {
                        return i.dic_section_id > 0
                    })
                    that.dic_section_arr = _.reduce(
                        _.groupBy(sectionList, `dic_section_id`),
                        function(result, value, key) {
                            let sOne = _.find(that.section_auth, d => {
                                return d.value == key
                            }) || { value: parseInt(key), label: value[0].dic_section, jianpin: value[0].dic_section }
                            result.push(sOne)
                            return result
                        },
                        []
                    )
                    if (that.dic_section_id != ``) {
                        allschedules = _.filter(allschedules, function(i) {
                            return i.dic_section_id == that.dic_section_id
                        })
                    }

                    if (that.proc_GetTipItemsSchedule) {
                        that.getSurgeryTipItems(allschedules)
                    }
                    console.log(`allschedules`, allschedules)
                    resolve(allschedules)
                    // added by xiaorui，是否显示传染病提示
                    // if (this.$root.IsShowInfectiousAlert && this.$root.IsShowInfectiousAlert == `1`) {
                    //     let alertmsg = ``
                    //     _.filter(
                    //         allschedules,
                    //         i => i.infectious && i.infectious != `无` && i.infectious != `NONE` && i.infectious != `NoCheck` && i.infectious != `未查` && i.infectious != `未检查`
                    //     ).map(d => {
                    //         alertmsg += `<strong>${d.patient_name}是${d.infectious}患者</strong><br/>`
                    //     })
                    //     if (alertmsg) {
                    //         this.$alert(alertmsg, `提示`, {
                    //             dangerouslyUseHTMLString: true,
                    //             type: `warning`
                    //         })
                    //         return true
                    //     }
                    // }
                    let alertmsg = ``
                    // 存储过程
                    if (that.showSurgeryAlert && that.showSurgeryAlert.trim() != `` && alertInfo.length > 0) {
                        let ids = _.map(allschedules, d => d.id)
                        alertInfo = _.filter(alertInfo, function(i) {
                            return _.includes(ids, i.biz_surgeryinfo_id)
                        })
                        console.log(alertInfo)
                        alertInfo.forEach(t => {
                            alertmsg += `<strong>${t.msg}</strong><br/>`
                        })
                    } else if (that.isShowInfectiousAlertConfigs && that.isShowInfectiousAlertConfigs.length > 0) {
                        that.isShowInfectiousAlertConfigs.forEach(t => {
                            _.filter(allschedules, i => i[t.Field] && i[t.Field] != `无` && i[t.Field] != `NONE` && i[t.Field] != `NoCheck` && i[t.Field] != `未查` && i[t.Field] != `未检查`).map(
                                d => {
                                    alertmsg += `<strong>姓名：“${d.patient_name}”；科室：“${d.dic_section}”； 床号：“${d.bed_no}” 是${d[t.Field]}${t.Remark}患者</strong><br/>`
                                }
                            )
                        })
                    }
                    if (alertmsg && alertmsg != `` && that.lastalertmsg != alertmsg) {
                        that.lastalertmsg = alertmsg
                        this.$alert(alertmsg, `提示`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                        return true
                    }
                    // added by xiaorui，是否显示二次手术提示
                    if (this.$root.IsShowMutiSurgery && this.$root.IsShowMutiSurgery == `1`) {
                        let alertmsg1 = ``
                        _.filter(allschedules, i => i.muti_surgery_count > 0).map(d => {
                            alertmsg1 += `<strong>${d.patient_name}已在${this.$moment(d.surgery_time).format(`YYYY-MM-DD HH:mm`)}手术,本次为第${d.muti_surgery_count + 1}次提交手术;</strong><br/>`
                        })

                        if (alertmsg1) {
                            this.$alert(alertmsg1, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                            return true
                        }
                    }
                })
            })
        },
        getSurgeryTipItems(r) {
            let that = this
            // 勾选了全部，取的是过去一周到未来30天所有的数据
            let begin = that.dataArea ? that.$moment().add(-7, `days`).format(`YYYY/MM/DD`) : that.$moment(that.scheduling_date).format(`YYYY/MM/DD`)
            let end = that.dataArea ? that.$moment().add(30, `days`).format(`YYYY/MM/DD`) : that.$moment(that.scheduling_date).add(1, `days`).format(`YYYY/MM/DD`)
            let req = this.myaxios.post(
                `api/Intraoperative/Anaesthesia/GetSurgeryTipItems`,
                {
                    begin: begin,
                    end: end,
                    surgery_status: [10, 20, 30, 40, 50, 60],
                    proc_key: that.proc_GetTipItemsSchedule
                },
                null,
                false
            )
            req.then(data => {
                if (r && data && data.length) {
                    _.forEach(r, d => {
                        let surgeryTip = data.filter(i => i.biz_surgeryinfo_id == d.id) || []
                        that.$set(d, `patientInfoTipItemsList`, surgeryTip)
                    })
                    this.$refs[`surgery-list`].AppendListData(r)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        loadActiveRoomScheduled() {
            // 获取各手术间排程数据
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetScheduled`, { date: that.scheduling_date, roomId: that.active_room_id })
                req.then(data => {
                    let allschedules = data
                    // 根据选择的手术类型做过滤，择期，急诊，日间
                    if (that.selectsurgeryType > 0) {
                        if (that.selectsurgeryType == 1 || that.selectsurgeryType == 2) {
                            allschedules = _.filter(allschedules, function(i) {
                                return i.enum_surgery_type == that.selectsurgeryType
                            })
                        }

                        if (that.selectsurgeryType == 3) {
                            allschedules = _.filter(allschedules, function(i) {
                                return i.is_day_surgery == true
                            })
                        }
                    }
                    var sectionList = _.filter(allschedules, function(i) {
                        return i.dic_section_id > 0
                    })
                    that.dic_section_arr = _.reduce(
                        _.groupBy(sectionList, `dic_section_id`),
                        function(result, value, key) {
                            let sOne = _.find(that.section_auth, d => {
                                return d.value == key
                            }) || { value: parseInt(key), label: value[0].dic_section, jianpin: value[0].dic_section }
                            result.push(sOne)
                            return result
                        },
                        []
                    )
                    let r = []
                    if (this.IsHavePermission(`scheduling:CrossRegionScheduling`)) {
                        r = _.filter(allschedules, c => {
                            return _.includes(that.dic_operating_ward_id_arr, c.dic_operating_ward_id)
                        })
                    } else {
                        r = _.filter(allschedules, { dic_operating_ward_id: that.dic_operating_ward_id })
                    }
                    if (that.dic_section_id != ``) {
                        r = _.filter(r, function(i) {
                            return i.dic_section_id == that.dic_section_id
                        })
                    }

                    r = r.map(d => {
                        if (d.scheduled_sequence && this.IsNum(d.scheduled_sequence)) {
                            d.sequence_s = d.scheduled_sequence && parseInt(d.scheduled_sequence)
                        } else {
                            d.sequence_s = d.scheduled_sequence
                        }
                        if (that.surgeryNameConfig && _.includes(that.surgeryNameConfig, `Surgery_Region`) && d.surgery_region) {
                            var surgeriesT = ``
                            d.surgery_region.forEach(sritem => {
                                surgeriesT += sritem.surgery_name + (sritem.surgery_region && that.surgeryNameConfig.replace(`Surgery_Region`, sritem.surgery_region)) + `,`
                            })
                            d.surgeries = surgeriesT.slice(0, -1)
                        }
                        if (this.IsHavePermission(`scheduling_list_toScheduling`)) {
                            d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                        } else {
                            d.class_name = `ignore-drag`
                        }
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                        d.worker_photo = `` // 手术医生照片

                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                        return d
                    })
                    // let r1 = _.orderBy(r, [`display_order`, `dic_operating_room_id`])
                    that.activeRoomScheduled_list = r
                    if (that.proc_GetTipItemsSchedule) {
                        that.getSurgeryTipItems(r)
                    }
                    resolve(r)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        ReloadRoom() {
            // GET /api/Preoperative/Schedule/GetRooms
            let that = this
            let req = this.myaxios.get(`/api/Preoperative/Schedule/GetRooms`, { date: that.scheduling_date })
            req.then(data => {
                that.operation_ward_all = _.groupBy(data, `dic_operating_ward_id`)
                this.$nextTick(() => {
                    that.thistableHeight = (this.$refs[`roomrow`] && this.$refs[`roomrow`].offsetHeight)
                })
            }).catch(e => {
                console.log(e)
            })
        },
        roomDragOption(isopen) {
            return {
                animation: 0,
                group: { name: `room`, put: [`listview`, `fixed-listview`], pull: false },
                disabled: !isopen,
                ghostClass: `ghost`,
                sort: false
            }
        },
        loadScheduleHelper(command) {
            let that = this
            let req
            if (command == `section`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySection`, { date: that.scheduling_date })
                that.scheduling_way = 1
            }
            if (command == `worker`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySurgeon`, { date: that.scheduling_date })
                that.scheduling_way = 2
            }
            if (command == `surgery`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySurgery`, { date: that.scheduling_date })
                that.scheduling_way = 3
            }
            if (command == `autoOneKeySchedule`) {
                var msg = this.AutoOneKeyScheduleMsg

                this.$confirm(`提示`, {
                    title: `提示`,
                    message: msg,
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                }).then(() => {
                    that.scheduling_way = 4
                    that.myaxios.get(`/api/Preoperative/Schedule/GetOneKeyAutoSchedule`).then(data => {
                        that.ReloadRoom()
                        that.ReloadListData()
                        if (data) {
                            that.$message.success(data)
                        } else {
                            that.$message.success(`一键排程成功`)
                        }
                    }).catch(e => { })
                })
                    .catch(e => { })
                return
            }
            if (command == `changeRoom`) {
                let surgeryIds = []
                that.checkedRows.map(d => {
                    if (d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                    }
                })
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择已排程手术`)
                    return
                }
                this.changeRoom.title = `更换手术间`
                this.changeRoom.type = `change`
                that.loadChangeRoomForm(surgeryIds)
                return
            }
            if (command == `setAnesDoctor`) {
                let surgeryIds = []
                that.checkedRows.map(d => {
                    if (d.enum_surgery_status == 10) {
                        surgeryIds.push(d.id)
                    }
                })
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请手术`)
                    return
                }
                that.loadsetAnesDoctorForm(surgeryIds)
                return
            }
            if (command == `clearWorkers`) {
                let surgeryIds = []
                that.checkedRows.map(d => {
                    if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                    }
                })
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请或已排程手术`)
                    return
                }
                that.loadclearWorkersForm(surgeryIds)
                return
            }
            // let req = that.myaxios.get(command == 'section'?'/api/Preoperative/Schedule/GetAutoScheduleBySection':'/api/Preoperative/Schedule/GetAutoScheduleBySurgeon',{date:that.scheduling_date})
            req.then(data => {
                that.autoScheduleSurgeries = []
                if (this.IsHavePermission(`scheduling:CrossRegionScheduling`)) {
                    that.autoScheduleSurgeries = _.filter(data, c => {
                        return _.includes(that.dic_operating_ward_id_arr, c.dic_operating_ward_id)
                    })
                } else {
                    that.autoScheduleSurgeries = _.filter(data, { dic_operating_ward_id: that.dic_operating_ward_id })
                }
                // 深拷贝一个autoScheduleColumnList
                that.autoScheduleColumnListBand = _.cloneDeep(that.autoScheduleColumnList)
                if (that.scheduling_way == 2) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeon`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                } else if (that.scheduling_way == 3) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeries`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                    var matchRule = {
                        type: `string`,
                        prop: `match_rules`,
                        label: `匹配术式`,
                        width: `120`,
                        isListable: true
                    }
                    that.autoScheduleColumnListBand.splice(4, 0, matchRule)
                }

                // that.autoScheduleSurgeries = data
            }).catch(e => {
                that.autoScheduleSurgeries = []
            })
            that.autoScheduleVisible = true
        },
        ExtraButtonClick(target) {
            let e = {}
            ;({ index: e.index, row: e.row } = target)
            if (this[target.emit]) {
                this[target.emit](e)
            } else {
                this.$emit(target.emit, e)
            }
        },
        cancelAutoSchedule({ row, index }) {
            this.autoScheduleSurgeries.splice(index, 1)
        },
        confirmAutoSchedule() {
            let that = this
            if (that.autoScheduleSurgeries.length == 0) {
                this.autoScheduleVisible = false
                return
            }
            let reqs = []
            let cms = _.groupBy(that.autoScheduleSurgeries, `dic_operating_room_id`)
            _.forEach(cms, function(value, roomId) {
                let req = that.myaxios.put(
                    `/api/Preoperative/Schedule/ScheduleSurgeries?date=${that.scheduling_date}&roomId=${roomId}`,
                    value.map(v => v.id)
                )
                reqs.push(req)
            })

            that.myaxios
                .all(...reqs)
                .then(datas => {
                    that.$message.success(`保存成功`)
                    this.ReloadRoom()
                    that.ReloadListData()
                    this.autoScheduleVisible = false
                })
                .catch(e => {
                    console.log(e)
                    that.$message.error(`保存失败`)
                })
        },
        loadSettingForm(room) {
            // 有应用麻醉人员权限
            let haveAnesthetistPermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) >= 0
            // 有应用护士人员权限
            let haveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) >= 0
            if (haveAnesthetistPermission && !haveNursePermission) {
                this.roomSettings.buttons[0].label = `应用麻醉人员`
            }
            if (!haveAnesthetistPermission && haveNursePermission) {
                this.roomSettings.buttons[0].label = `应用护士人员`
            }
            if (!haveAnesthetistPermission && !haveNursePermission) {
                this.roomSettings.buttons = []
            }

            this.roomSettings.title = `手术间设置(${room.name})`
            this.roomSettings.dialogFormVisible = true
            let roomsetting = room.room_setting || {}
            roomsetting.dic_operating_ward_id = room.dic_operating_ward_id
            roomsetting.dic_operating_room_id = room.id
            roomsetting.id = roomsetting.id || 0
            if (roomsetting.anesthetist_assistant_id != null) {
                roomsetting.anesthetist_assistant_id =
                    roomsetting.anesthetist_assistant_id &&
                    roomsetting.anesthetist_assistant_id
                        .toString()
                        .split(`,`)
                        .map(d => parseInt(d))
            }
            if (roomsetting.circuit_nurse_id != null) {
                roomsetting.circuit_nurse_id =
                    roomsetting.circuit_nurse_id &&
                    roomsetting.circuit_nurse_id
                        .toString()
                        .split(`,`)
                        .map(d => parseInt(d))
            }
            if (roomsetting.equipment_nurse_id != null) {
                roomsetting.equipment_nurse_id =
                    roomsetting.equipment_nurse_id &&
                    roomsetting.equipment_nurse_id
                        .toString()
                        .split(`,`)
                        .map(d => parseInt(d))
            }
            roomsetting.checkedRows = this.checkedRows
            this.roomSettings.data = roomsetting
        },
        saveSettings(row) {
            let that = this
            let surgeryIds = []
            row.checkedRows.map(d => {
                if (d.enum_surgery_status == 20) {
                    surgeryIds.push(d.id)
                }
            })

            // 没有应用麻醉人员权限
            let noHaveAnesthetistPermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) === -1
            // 没有应用护士人员权限
            let noHaveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) === -1
            // 排程助手按钮权限
            let nointelligencePermission = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:intelligence`) === -1

            let step = new Promise((resolve, reject) => {
                if (this.$root.IsCheckRoomSettingWorker == `1`) {
                    var workerIds = []
                    if (row.roomForWorkerModels && row.roomForWorkerModels.length > 0) {
                        if (row.anesthetist_id) {
                            workerIds.push(parseInt(row.anesthetist_id))
                        }
                        if (row.anesthetist_assistant_id) {
                            workerIds = workerIds.concat(row.anesthetist_assistant_id)
                        }
                        if (row.circuit_nurse_id) {
                            workerIds = workerIds.concat(row.circuit_nurse_id)
                        }
                        if (row.equipment_nurse_id) {
                            workerIds = workerIds.concat(row.equipment_nurse_id)
                        }

                        if (workerIds.length > 0) {
                            var workerList = _.filter(row.roomForWorkerModels, function(o) {
                                return workerIds.indexOf(parseInt(o.worker_id)) > -1
                            })
                            if (workerList && workerList.length > 0) {
                                let msg = ``
                                _.forEach(workerList, function(value, key) {
                                    msg = `${msg}${value.worker_name},手术间:${value.setting_room_name},职责:${value.duty_name}<br/>`
                                })
                                this.$confirm(`提示`, {
                                    title: `提示`,
                                    message: `选择的人员已被安排，确定再次安排吗?<br/>${msg}`,
                                    confirmButtonText: `确定`,
                                    cancelButtonText: `取消`,
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                                    .then(() => {
                                        resolve()
                                    })
                                    .catch(() => {})
                            } else {
                                resolve()
                            }
                        } else {
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                } else {
                    resolve()
                }
            })

            step.then(() => {
                let req = that.myaxios.put(`/api/Preoperative/RoomSetting/Put`, {
                    id: row.id,
                    date: that.scheduling_date,
                    dic_operating_room_id: row.dic_operating_room_id,
                    dic_operating_room: {
                        id: row.dic_operating_room_id
                    },
                    anesthetist_id: noHaveAnesthetistPermission == true ? null : row.anesthetist_id,
                    anesthetist_assistant_id: noHaveAnesthetistPermission == true ? null : row.anesthetist_assistant_id && row.anesthetist_assistant_id.toString(),
                    circuit_nurse_id: noHaveNursePermission == true ? null : row.circuit_nurse_id && row.circuit_nurse_id.toString(),
                    equipment_nurse_id: noHaveNursePermission == true ? null : row.equipment_nurse_id && row.equipment_nurse_id.toString(),
                    dic_section_id: nointelligencePermission == true ? `-1` : row.dic_section_id || `-1`,
                    surgeon_id: nointelligencePermission == true ? `-1` : row.surgeon_id || `-1`,
                    dic_surgery_name: row.dic_surgery_name,
                    is_extra: row.isExtraBtnClick,
                    surgeryIds: surgeryIds
                })
                req.then(data => {
                    that.$message.success(`保存成功`)
                    this.ReloadRoom()
                    that.ReloadListData()
                    that.roomSettings.dialogFormVisible = false
                }).catch(e => {})
            })
        },
        loadChangeRoomForm(surgeryIds) {
            let that = this
            if (surgeryIds.length > 0) {
                this.changeRoom.dialogFormVisible = true
                this.changeRoom.data = { dic_recovery_ward_id: this.dic_operating_ward_id, surgeryIds: surgeryIds }
            } else {
                if (that.changeRoom.type == `change`) {
                    this.$message.warning(`请选择已排程手术！`)
                } else {
                    this.$message.warning(`请选择待排程手术！`)
                }
            }
        },
        changeRoomSave(row) {
            let that = this
            // added by xiaorui,2022-04-05 ,ACIS-23414,手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
            if (row.surgeryIds.length > 0) {
                let req = ``
                let title = ``
                if (that.changeRoom.type == `change`) {
                    title = `更换手术间`
                    req = that.myaxios.put(
                        `/api/Preoperative/Schedule/ChangeRoom?operatingRoomId=${row.dic_operating_room_id}&operatingWardId=${row.dic_recovery_ward_id}&date=${this.scheduling_date}`,
                        row.surgeryIds
                    )
                    req.then(data => {
                        let rooIds = [that.active_room_id]
                        this.ReScheduleSurgeries(rooIds).then(ds => {
                            that.ReloadRoom()
                            that.ReloadListData()
                            that.$message.success(`${title}成功`)
                            that.changeRoom.dialogFormVisible = false
                        })
                    }).catch(e => {
                        that.$message.error(`${title}失败`)
                    })
                } else {
                    title = `排程`

                    that.checkSurgery(row.surgeryIds).then((d) => {
                        if (d && d != ``) {
                            this.$confirm(d, `提示`, {
                                confirmButtonText: `确定排程`,
                                cancelButtonText: `取消排程`,
                                type: `warning`,
                                closeOnClickModal: false
                            })
                                .then(() => {
                                    that.doScheduleSurgeries(that.scheduling_date, row.dic_operating_room_id, row.surgeryIds, 3)
                                })
                                .catch(e => {})
                        } else {
                            that.doScheduleSurgeries(that.scheduling_date, row.dic_operating_room_id, row.surgeryIds, 3)
                        }
                    })
                }
            }
        },
        loadclearWorkersForm(surgeryIds) {
            if (surgeryIds.length > 0) {
                this.clearWorkers.title = `清除手术安排人员`
                this.clearWorkers.dialogFormVisible = true
                this.clearWorkers.workerDuties = null
                this.clearWorkers.data = { surgeryIds: surgeryIds }
            } else {
                this.$message.warning(`请选择新申请或已排程手术！`)
            }
        },
        setClearWorkersSave() {
            let that = this
            let surgeryIds = that.clearWorkers.data.surgeryIds
            let duties = that.clearWorkers.workerDuties
            if (duties && duties.length > 0) {
                let inputData = {
                    surgeryIds: surgeryIds,
                    workerDuties: duties
                }
                let req = that.myaxios.put(`/api/Preoperative/Schedule/SetClearWorkersSurgeries`, inputData)
                req.then(data => {
                    that.ReloadListData()
                    that.$message.success(`清除成功`)
                    that.clearWorkers.dialogFormVisible = false
                }).catch(e => {
                    that.$message.error(`清除失败`)
                })
            }
        },
        loadsetAnesDoctorForm(surgeryIds) {
            if (surgeryIds.length > 0) {
                this.setAnesDoctor.title = `设置麻醉医生`
                this.setAnesDoctor.dialogFormVisible = true
                this.setAnesDoctor.data = { plan_anes_doctor: this.plan_anes_doctor, surgeryIds: surgeryIds }
            } else {
                this.$message.warning(`请选择新申请手术！`)
            }
        },
        setAnesDoctorSave(row) {
            let that = this
            // ACIS-23812增加批量设置麻醉医生
            if (row.surgeryIds.length > 0) {
                let req = that.myaxios.put(`/api/Preoperative/Schedule/SetAnesDoctorSurgeries?plan_anes_doctor=${row.plan_anes_doctor.value}`, row.surgeryIds)
                req.then(data => {
                    that.ReloadRoom()
                    that.ReloadListData()
                    that.$message.success(`设置麻醉医生成功`)
                    that.setAnesDoctor.dialogFormVisible = false
                }).catch(e => {
                    that.$message.error(`设置麻醉医生失败`)
                })
            }
        },
        exportExcelSave(row) {
            let data = this.exportExcel.exportDatas
            if (row.status.length > 0 && data.length > 0) {
                let filterExportData = !_.has(data[0], `状态`)
                    ? data
                    : _.filter(data, c => {
                        return _.includes(row.status, c[`状态`])
                    })
                if (filterExportData.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                this.myaxios.export_excel(filterExportData, `手术排程.xls`).then(data => {
                    this.exportExcel.dialogFormVisible = false
                    this.exportExcel.exportDatas = []
                })
            }
        },
        loadSurgeryEditView({ row }) {
            this.edit.surgeryId = row.id
            this.edit.dialogFormVisible = true
            if (row.enum_surgery_status == 10) {
                this.editButtons = [
                    {
                        label: `确认排程`,
                        type: `default`,
                        permission: `ApplySurgery:ConfirmSchedule`
                    }
                ]
            } else {
                this.editButtons = []
            }
        },
        printOne({ row }) {
            this.$store.dispatch(`PRINT_PDF`, {
                host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.PC008,
                    id1: row.id,
                    objId: row.id
                }
            })
        },
        checkedRow({ row }) {
            this.checkedRows = row
        },
        ReloadListData() {
            console.log(`定时调surgery-list ReloadListData方法`)
            if (this.$refs[`surgery-list`]) {
                this.$refs[`surgery-list`].ReloadListData()
            }
            // this.LoadScheduledByWard()
        },
        // 新手术申请通知
        loadNewSurgeryList() {
            if (this.$root.IsShowNewSurgeryAlert && this.$root.IsShowNewSurgeryAlert == `1` && this.dic_operating_ward_id) {
                this.myaxios.get(`/api/Preoperative/Apply/GetNewApplySurgerys`, { wardId: this.dic_operating_ward_id, syncMinutes: this.$root.SurgeryInfoSyncTime }).then(data => {
                    if (data && data.length > 0) {
                        // added by 是否显示新手术通知提示
                        let alertmsg2 = ``
                        _.filter(data, i => i.surgery_status == `新申请`).map(d => {
                            alertmsg2 += `<strong>${d.patient_name}是新手术申请</strong><br/>`
                        })
                        if (alertmsg2) {
                            this.$notify.info({
                                title: `提醒`,
                                dangerouslyUseHTMLString: true,
                                message: alertmsg2,
                                position: `bottom-right`,
                                duration: 15000,
                                offset: 100
                            })
                            return true
                        }
                    }
                })
            }
        },
        printSurenry(command) {
            // 导出Excel
            if (command == `ExportExcel`) {
                let from = this.$moment(this.scheduling_date).format(`YYYY-MM-DD`)
                let to = this.$moment(this.scheduling_date)
                    .add(1, `days`)
                    .format(`YYYY-MM-DD`)
                this.myaxios.get(`/api/Preoperative/Schedule/GetScheduleForExport`, { wardId: this.dic_operating_ward_id, from: from, to: to }).then(data => {
                    if (data.length <= 0) {
                        this.$message.warning(`暂无导出数据`)
                        return
                    }
                    // 是否需要按状态过滤
                    let filterdata = this.isEnableFilterStatusForExportExcel && this.isEnableFilterStatusForExportExcel == `1`
                    if (filterdata) {
                        this.exportExcel.exportDatas = data
                        this.exportExcel.dialogFormVisible = true
                    } else {
                        this.myaxios.export_excel(data, `手术排程.xls`)
                    }
                })
            } else {
                if (command && command.code && command.type) {
                    if (command.type == 2 || command.type == 3 || command.type == 4 || command.type == 5) {
                        // 日期阶段打印
                        this.printSurenryForm.code = command.code
                        this.printSurenryForm.type = command.type
                        this.printSurenryForm.dialogFormVisible = true
                        this.printSurenryForm.from_to = [this.$moment(this.scheduling_date).format(`YYYY/MM/DD 00:00:00`), this.$moment(this.scheduling_date).format(`YYYY/MM/DD 23:59:59`)]
                        if (command.type == 5) {
                        // 默认设置成今天
                            this.printSurenryForm.from_to = [this.$moment().format(`YYYY/MM/DD 00:00:00`), this.$moment().format(`YYYY/MM/DD 23:59:59`)]
                        }
                        this.printSurenryForm.roomids = []
                        this.printSurenryForm.wardids = []
                        if (command.extradata != null && command.extradata != ``) {
                            this.printSurenryForm.extradata = command.extradata
                        }
                        let r = _.filter(this[`operation_ward_auth`], { value: parseInt(this.dic_operating_ward_id) })
                        console.log(`手术间`)
                        this.printSurenryForm.rooms = (r && r[0] && r[0].operation_room) || []
                    } else {
                        let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                        req2.then(isShow => {
                            // 选择打印
                            // 批量打印手术通知单
                            if (command.type == 1) {
                                let printlist = []
                                if (this.checkedRows.length < 1) {
                                    printlist = this.scheduled_list
                                } else {
                                    printlist = this.checkedRows
                                }
                                if (printlist.length) {
                                    this.$store.dispatch(`PRINT_PDF`, {
                                        host: this.$root.DOCSERVICE_BASE,
                                        params: Object.assign(
                                            {
                                                docid: this.$root.DOCUMENT[command.code],
                                                id1: `99999`,
                                                objId: printlist.map(d => d.id).toString()
                                            },
                                            { isShowSendPrintMessage: isShow.value }
                                        )
                                    })
                                } else {
                                    this.$message.warning(`请选择需要打印的手术通知`)
                                }
                            } else {
                                // 打印当天
                                this.$store.dispatch(`PRINT_PDF`, {
                                    host: this.$root.DOCSERVICE_BASE,
                                    params: Object.assign(
                                        {
                                            docid: this.$root.DOCUMENT[command.code],
                                            id1: ``,
                                            objId: `${this.dic_operating_ward_id}|${this.scheduling_date}`,
                                            from: this.$moment(this.scheduling_date).format(`YYYYMMDDHHmm`),
                                            to: this.$moment(this.scheduling_date)
                                                .add(1, `days`)
                                                .format(`YYYYMMDDHHmm`)
                                        },
                                        { isShowSendPrintMessage: isShow.value }
                                    )
                                })
                            }
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                }
            }
        },
        printSurenryByTime() {
            console.log(`printSurenryForm`, this.printSurenryForm)
            this.printSurenryForm.dialogFormVisible = false
            if (this.printSurenryForm.type == 2 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                // 自定义execl打印
                this.myaxios
                    .get(`/api/Preoperative/Schedule/GetScheduleExtradata`, {
                        wardId: this.dic_operating_ward_id,
                        from: this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`),
                        to: this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`),
                        objs: ``
                    })
                    .then(data => {
                        if (data.length <= 0) {
                            this.$message.warning(`暂无导出数据`)
                            return
                        }
                        this.myaxios.export_excel_Extradata(
                            this.printSurenryForm.extradata.ExportUrl,
                            data,
                            `手术排程.xls`,
                            `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`
                        )
                    })
            } else if (this.printSurenryForm.type == 3 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                let wardId = this.dic_operating_ward_id
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let roomids = this.printSurenryForm.roomids && this.printSurenryForm.roomids.join(`,`)
                let tempInfo = this.printSurenryForm.extradata.tempInfo
                let xlsName = `手术排程.xls`
                let shapb = `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`
                if (tempInfo) {
                    let tempArr = tempInfo.split(`|`)
                    if (tempArr.length != 2) {
                        this.$message.warning(`请确认导出模板配置`)
                        return
                    }
                    let tempname = tempArr[0]
                    let procname = tempArr[1]
                    xlsName = tempname + `.xls`
                    shapb = tempname + `(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`

                    this.myaxios
                        .export_excel_Template(this.printSurenryForm.extradata.ExportUrl + `?wardId=${wardId}&roomids=${roomids}&from=${from}&to=${to}&procname=${procname}`, null, xlsName,
                            shapb)
                } else {
                    this.myaxios
                        .export_excel_Template(this.printSurenryForm.extradata.ExportUrl + `?wardId=${wardId}&roomids=${roomids}&from=${from}&to=${to}`, null, xlsName,
                            shapb)
                }
            } else if (this.printSurenryForm.type == 4 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let wardids = this.printSurenryForm.wardids && this.printSurenryForm.wardids.join(`,`)
                this.myaxios
                    .export_excel_Template(this.printSurenryForm.extradata.ExportUrl + `?wardids=${wardids}&from=${from}&to=${to}`, null, `手术排程.xls`,
                        `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`)
            } else {
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let wardids = this.printSurenryForm.wardids && this.printSurenryForm.wardids.join(`,`)
                let objIdstr = `${this.dic_operating_ward_id}|${from}-${to}`
                if (this.printSurenryForm.type == 4) {
                    objIdstr = `${wardids}|${from}-${to}`
                }
                console.log(`objId`, objIdstr)
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.$root.DOCUMENT[this.printSurenryForm.code],
                                id1: ``,
                                objId: objIdstr,
                                from: this.$moment(this.printSurenryForm.from_to[0]).format(`YYYYMMDDHHmm`),
                                to: this.$moment(this.printSurenryForm.from_to[1]).format(`YYYYMMDDHHmm`)
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        exchangeRoom($event) {
            let that = this
            let {
                moved: { newIndex, oldIndex }
            } = $event
            let oldEle = that.operationRoom[oldIndex]
            let newEle = that.operationRoom[newIndex]
            that.$confirm(`确认将 ${oldEle.name} 与 ${newEle.name} 当日排程进行交换?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = that.myaxios.put(`/api/Preoperative/Schedule/ExchangeRoom?roomA=${oldEle.id}&roomB=${newEle.id}&date=${this.scheduling_date}`)
                    req.then(data => {
                        // let old_v =  oldEle.visit
                        // oldEle.visit = newEle.visit
                        // newEle.visit = old_v
                        this.ReloadRoom()
                        this.ReloadListData()
                        that.$message.success(`交换成功`)
                    }).catch(e => {
                        // that.$message.error('交换失败')
                    })
                })
                .catch(e => {})
        },
        dragSort({ newrow, oldrow }) {
            let that = this
            // let newSequence = newrow.sequence_s
            let tmp = 0
            if (newrow.enum_surgery_status >= 30) {
                that.$message.error(`手术中或已完成的手术无法更换台次`)
                newrow.sequence_s = oldrow.sequence_s
                tmp = this.active_room_id
                this.active_room_id = 0
                setTimeout(() => {
                    this.active_room_id = tmp
                }, 100)
                return
            }

            let req = this.myaxios.put(`/api/Preoperative/Schedule/JumpSequence/${oldrow.id}?oldsequence=${oldrow.sequence_s}&sequence=${newrow.sequence_s}`)
            req.then(() => {
                let rooIds = [that.active_room_id]
                this.ReScheduleSurgeries(rooIds).then(ds => {
                    this.ReloadRoom()
                    this.ReloadListData()
                })
            })
        },
        clearButtonFocus() {
            this.$nextTick(() => {
                let active = document.activeElement
                if (active && typeof active.blur === `function`) {
                    active.blur()
                }
            })
        },
        LoadUnScheduled() {
            this.isLoadToSchedule = !this.isLoadToSchedule
            this.active_room_id = 0
            this.clearButtonFocus()
        },
        LoadAllScheduled() {
            this.isLoadScheduled = !this.isLoadScheduled
            this.active_room_id = 0
            this.clearButtonFocus()
        },
        LoadCancelScheduled() {
            this.isLoadCancelScheduled = !this.isLoadCancelScheduled
            this.active_room_id = 0
            this.clearButtonFocus()
        },
        LoadActiveRoomData(event, room) {
            let that = this
            let scrollLeft = that.$refs.scrollpaneRef && that.$refs.scrollpaneRef.scrollWrapper.scrollLeft

            if (this.active_room_id == room.id) {
                this.active_room_id = 0
            } else {
                this.isLoadToSchedule = false
                this.isLoadScheduled = false
                this.isLoadCancelScheduled = false
                this.active_room_id = room.id
                this.$nextTick(() => {
                    if (that.$refs.scrollpaneRef) {
                        let $scrollWrapper = that.$refs.scrollpaneRef.scrollWrapper
                        $scrollWrapper.scrollLeft = scrollLeft
                    }
                })
            }
        },
        loadCheckList(room) {
            this.active_item.room_setting = room.room_setting
            this.active_item.date = this.$moment(room.room_setting.date).format(`YYYY-MM-DD`)
            this.active_item.check_date = room.room_setting.check_date
            this.active_item.dic_operating_room_id = room.id
            this.active_item.check_user_id = room.room_setting.check_user_id
            this.dialogFormVisible1 = true
            this.$nextTick(() => {
                this.$refs.doc && this.$refs.doc.loadDocument()
            })
        },
        afterDocSaved() {
            let req = this.myaxios.put(`/api/Preoperative/RoomSetting/Put`, {
                id: this.active_item.room_setting.id,
                date: this.active_item.room_setting.date,
                dic_operating_room_id: this.active_item.dic_operating_room_id,
                check_user_id: this.active_item.check_user_id,
                check_date: this.active_item.check_date,
                check_result: this.btn_chk_result
            })

            req.then(data => {
                this.refreshList()
                this.dialogFormVisible1 = false
            }).catch(e => {
                console.log(e)
            })
        },
        SaveChanges(result) {
            let valid = true
            this.btn_chk_result = result
            if (valid) {
                this.$refs.doc.save()
            }
        },
        loadRoomStyle() {
            let config = JSON.parse(this.ScheduleRoomStyleSetting)
            if (config.字体颜色) {
                this.roomStyle.color = config.字体颜色
            } else {
                this.roomStyle.color = ``
            }
            let fontsize = parseInt(config.字体大小)
            if (fontsize && fontsize > 0) {
                this.roomStyle.fontSize = fontsize + `px`
            } else {
                this.roomStyle.fontSize = ``
            }
            if (config.背景色) {
                this.roomStyle.backgroundColor = config.背景色
            } else {
                this.roomStyle.backgroundColor = ``
            }

            if (config.选中后字体颜色) {
                this.roomStyle.activecolor = config.选中后字体颜色
            }
            let activefontsize = parseInt(config.选中后字体大小)
            if (activefontsize && activefontsize > 0) {
                this.roomStyle.activefontSize = activefontsize + `px`
            }
            if (config.选中后背景色) {
                this.roomStyle.activebackgroundColor = config.选中后背景色
            }

            let config2 = JSON.parse(this.settingRoomBgColor)
            if (config2.是否启用) {
                this.roomStyle.isEnable = config2.是否启用
            }
            if (config2.是否启用 && config2.是否启用 === `1`) {
                if (config2.背景色) {
                    this.roomStyle.bgColor = config2.背景色
                }
                if (config2.选中后背景色) {
                    this.roomStyle.activebgColor = config2.选中后背景色
                }
            }
        },
        changed(changed) {
            this.selectsurgeryType = changed
            this.ReloadListData()
        },
        // true:数值型的，false：非数值型
        IsNum(value) {
            return !isNaN(value)
        },
        DisplayOrderNumber(str, type) {
            let that = this
            let r = _.find(type == `section` ? that.section_auth : that.operation_room_auth, { label: str })
            return (r && r.display_order) || 10000
        }
    },
    watch: {
        scheduling_date: function() {
            // 更改日期触发更新列表
            this.refreshList()
        },
        active_room_id: function() {
            // 更改当前手术室触发更新列表
            let that = this
            that.checkedRows = []
            if (this.active_room_id > 0) {
                this.ReloadListData()
            }
        },
        dic_operating_ward_id: function(newVlaue, oldValue) {
            // sessionStorage.setItem(`memory_operating_ward_id`, newVlaue)
            // 更改日期触发更新列表
            this.ReloadListData()
        },
        dic_operating_ward_id_arr: function(newVlaue, oldValue) {
            // sessionStorage.setItem(`memory_operating_ward_id`, newVlaue)
            // 更改日期触发更新列表
            this.ReloadListData()
        },
        dic_section_id: function(newVlaue, oldValue) {
            // 更改科室触发更新列表
            this.ReloadListData()
        },
        dataArea: function() {
            // 更改日期触发更新列表
            this.ReloadListData()
        },
        isLoadToSchedule: function() {
            this.scrolling_in_id = 0
            // 触发更新列表
            this.refreshList()
        },
        isLoadScheduled: function() {
            this.scrolling_in_id = 0
            // 触发更新列表
            this.refreshList()
        },
        isLoadCancelScheduled: function() {
            this.scrolling_in_id = 0
            // 触发更新列表
            this.refreshList()
        },
        active_ward: function() {
            if (this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                sessionStorage.setItem(`consd`, null)
                this.o_dic_operating_ward_id = this.active_ward.origion
                this.o_dic_operating_ward_id_arr = [this.active_ward.origion]
            }
        }
    }
}
</script>
<style lang="less">
/* 拖拽时的样式控制 */
.room tr {
    display: none;
}

.room .drag_target {
    color: black !important;
    outline: dotted 0.5px gray;
}

.surgery-status-tag {
    width: 12px;
    float: left;
}

.surgery-num-tag {
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    // display: -moz-inline-box; /* css注释：for ff2 */
    // display: inline-block;
    float: right;
    margin-right: 10px;
}

.el-tag-dp {
    color: #52b8d2;
    border-color: #52b8d2;
    background-color: white;
}

.workerImg {
    float: left;
    padding: 2px 15px;
    width: 16px;
    height: 16px;
}

.workerImg:hover {
    cursor: pointer;
    transform: scale(1.2);
}

.more {
    height: 50px;
    line-height: 45px;
    margin-left: 10px;
    border-radius: 5px;
}

.more:hover {
    cursor: pointer;
    border: solid 0.5px var(--primary-color, #009688);
    font-weight: bold;
    color: var(--primary-color, #009688);
    opacity: 1;
}
.room-card {
  margin: 4px;
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  background: #ecf5ff;
  color: #409eff;
}
.room-card:hover,
.room-card.active {
  background: #409eff;
  color: #fff;
}
.group-title {
  font-weight: bold;
  margin: 12px 0 6px;
}
.blue { color: #409EFF; }
.yellow { color: #E6A23C; }

.nurse-group {
  margin-bottom: 12px;
}
.nurse-tag {
  position: relative;
  padding: 6px 10px;
  margin-bottom: 6px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  border: 1px solid #dcdcdc;
  transition: all .2s;
  display: inline-block;
}
.nurse-tag.selected {
  background: var(--primary-color, #009688);
  color: #fff;
  border-color: var(--primary-color, #009688);
}
.delete-icon {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 16px;
        height: 16px;
        background-color: #f56c6c;
        border-radius: 50%;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        cursor: pointer;
        transition: all 0.3s;
}
.delete-icon:hover {
    background-color: #f78989;
    transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/ScheduleSurgery.vue